<template>
  <div>
    <section
      v-if="info.renter.name"
      ref="tenantView"
      class="tenant-view"
    >
      <div class="lien-details-header pb-4">
        <h4>Lien Overview</h4>
        <div
          ref="pageNavigationContainer"
          class="
            flex
            items-center
            overflow-x-auto
            w-full
            space-x-2
            pb-4
            page-navigation
          "
        >
          <a
            v-for="val in navLinks"
            :id="`${val.key}-link`"
            :key="val.id"
            class="
              whitespace-nowrap
              border
              dark:text-white
              text-foreground
              rounded
              px-2
              py-2
              xl:py-1
            "
            :class="{
              'bg-muted-100 border-muted-300 dark:bg-muted-800 dark:border-muted-600': !val.isActive,
              'bg-primary-200 border-primary-400 dark:bg-primary-500 dark:border-primary-700': val.isActive
            }"
            @click="handleNavLinks(val.id, val.key)"
          >
            {{ val.name }}
          </a>
        </div>
      </div>

      <!-- <lien-details
        :info="info"
        @updated="getTenantInfo"
      /> -->

      <div
        ref="lienDetails"
        data-key="lienDetails"
        class="lien-details-wrapper lien-wrapper"
      >
        <h5 class="lien-details-wrapper-title">
          Lien Details
        </h5>
        <div
          class="
            grid
            grid-cols-1
            sm:grid-flow-col
            md:grid-cols-2
            grid-rows-none
            xl:grid-cols-3
            sm:grid-rows-6
            lg:grid-rows-5
            gap-2
            mb-4
          "
        >
          <!-- @todo should be v-for -->
          <div class="lien-value-box">
            <dt>Tenant Name</dt>
            <dd>{{ tenantFullName }}</dd>
          </div>
          <div class="lien-value-box">
            <dt>Company Name</dt>
            <dd>{{ info.renter?.company_name || '-' }}</dd>
          </div>
          <div class="lien-value-box">
            <dt>Email</dt>
            <dd>
              <a
                v-if="info.renter.email"
                :href="'mailto:' + info.renter.email"
                target="_blank"
                class=""
              >
                {{ info.renter.email.toLowerCase() }}
              </a>

              <span
                v-else
                class="lien-box-missing"
              >
                Missing Email
              </span>
            </dd>
          </div>
          <div class="lien-value-box">
            <dt>Phone</dt>
            <dd>
              <a
                v-if="info.renter.homephone"
                :href="'tel:' + info.renter.homephone"
                target="_blank"
                class="lien-box-val"
              >
                {{ info.renter.homephone }}
              </a>
              <span
                v-else
                class="lien-box-missing"
              >
                Missing Phone
              </span>
            </dd>
          </div>
          <div class="lien-value-box">
            <dt>Mobile</dt>
            <dd>
              <a
                v-if="info.renter.cellphone"
                :href="'tel:' + info.renter.cellphone"
                target="_blank"
                class="lien-box-val"
              >
                {{ info.renter.cellphone }}
              </a>
              <span
                v-else
                class="lien-box-missing"
              >
                Missing Mobile
              </span>
            </dd>
          </div>
          <div class="lien-value-box">
            <dt>Location Name</dt>
            <dd>
              {{ info.renter.company?.name ?? '-' }}
            </dd>
          </div>
          <div class="lien-value-box">
            <dt>Unit Number</dt>
            <dd>
              {{ info.renter.unit_number ?? '-' }}
            </dd>
          </div>
          <div class="lien-value-box">
            <dt>Unit Size</dt>
            <dd>
              {{ info.renter.unit_size || '-' }}
            </dd>
          </div>
          <div class="lien-value-box">
            <dt>Paid Through</dt>
            <dd>
              <!-- @todo date formatting -->
              {{ info.renter.next_due_date ?? '-' }}
            </dd>
          </div>
          <div class="lien-value-box">
            <dt>Due Amount</dt>
            <dd>
              {{ info.renter.chargesbal ? formatMoneyValue(info.renter.chargesbal) : '-' }}
            </dd>
          </div>
          <div class="lien-value-box">
            <dt>Lien Status</dt>
            <dd
              :data-tooltip="status.description"
              class="has-tooltip-left has-tooltip-multiline"
            >
              <span :style="{ 'color': status.foreground, 'background': status.background, 'padding': '4px 8px', 'border-radius': '8px' }">
                {{ status.name ?? '-' }}
              </span>
            </dd>
          </div>
          <div class="lien-value-box">
            <dt>Description</dt>
            <dd
              class="flex justify-between items-center has-tooltip-left has-tooltip-multiline"
              :data-tooltip="info.renter?.description || false"
            >
              <span
                class="line-clamp-1 cursor-default"
              >
                {{ info.renter?.description || '-' }}
              </span>
              <i
                class="fas fa-pencil-alt ml-2 text-primary-500 p-1 bg-transparent rounded hover:bg-primary-200 transition-colors cursor-pointer"
                @click="showAddEditDescriptionModal"
              />
            </dd>
          </div>
          <div class="lien-value-box">
            <dt>Auction Start</dt>
            <dd class="flex justify-between items-center">
              {{ info.auctionModel.start || 'n/a' }}

              <i
                class="fas fa-pencil-alt ml-2 text-primary-500 p-1 bg-transparent rounded hover:bg-primary-200 transition-colors cursor-pointer"
                @click="auctionDialog = true"
              />
            </dd>
          </div>
          <div class="lien-value-box">
            <dt>Auction End</dt>
            <dd class="flex justify-between items-center">
              {{ info.auctionModel.end || 'n/a' }}

              <i
                class="fas fa-pencil-alt ml-2 text-primary-500 p-1 bg-transparent rounded hover:bg-primary-200 transition-colors cursor-pointer"
                @click="auctionDialog = true"
              />
            </dd>
          </div>

          <al-dialog
            v-model="auctionDialog"
            title="Auction Date Selection"
          >
            <!-- <div class="flex items-center">
              <input
                :value="info.auctionModel.start"
                readonly
              >

              <i class="fas fa-arrow-right mx-2" />

              <input
                :value="info.auctionModel.end"
                readonly
              >
            </div> -->

            <!-- <vc-date-picker
              v-model="info.auctionModel"
              class="mt-4 w-full"
              mode="dateTime"
              :timezone="timezone"
              :is-dark="isDark"
              is-range
              is-expanded
            /> -->

            <vc-date-picker
              v-model="info.auctionModel"
              mode="dateTime"
              is-range
              :timezone="timezone"
              :is-dark="isDark"
            >
              <template #default="{ inputValue, inputEvents, isDragging }">
                <div class="flex flex-col sm:flex-row justify-start items-center">
                  <div class="relative flex-grow">
                    <svg
                      class="text-muted-600 w-4 h-full mx-2 absolute pointer-events-none"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                      />
                    </svg>
                    <input
                      class="flex-grow !pl-8 pr-2 py-1"
                      :class="isDragging ? 'text-muted-600' : 'text-gray-900'"
                      :value="inputValue.start"
                      v-on="inputEvents.start"
                    >
                  </div>
                  <span class="flex-shrink-0 m-2">
                    <i class="fas fa-arrow-right mx-2" />
                  </span>
                  <div class="relative flex-grow">
                    <svg
                      class="text-muted-600 w-4 h-full mx-2 absolute pointer-events-none"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                      />
                    </svg>
                    <input
                      class="flex-grow !pl-8 pr-2 py-1"
                      :class="isDragging ? 'text-muted-600' : 'text-gray-900'"
                      :value="inputValue.end"
                      v-on="inputEvents.end"
                    >
                  </div>
                </div>
              </template>
            </vc-date-picker>

            <template #actions="{ close }">
              <button
                class="button is-white"
                @click="close()"
              >
                Cancel
              </button>
              <button
                class="button primary"
                @click="saveAuction"
              >
                Save
              </button>
            </template>
          </al-dialog>

          <div
            v-if="role === roles.SUPER_ADMIN"
            class="flex flex-col justify-between"
          >
            <!-- <al-button
              primary
              @click="auctionDialog = true"
            >
              Change Auction Date
            </al-button> -->

            <button
              class="button has-text-weight-bold final-approval-button"
              :class="
                !finalApproval || finalApproval?.disabled
                  ? 'has-background-grey-light'
                  : info.renter.status_done
                    ? 'is-success'
                    : 'is-warning'
              "
              :disabled="!finalApproval || finalApproval?.disabled"
              @click="showApproveModal"
            >
              Confirm Auction Completed
            </button>
          </div>
        </div>
      </div>
      <div
        ref="workflow"
        data-key="workflow"
        class="lien-details-wrapper lien-wrapper"
      >
        <h5 class="lien-details-wrapper-title">
          Workflow Progress
        </h5>
        <div
          v-if="info.current_liens[0]"
          class="columns"
        >
          <div class="column is-12 is-paddingless">
            <div class="horizontal-timeline">
              <div
                v-for="(step, idx) in info.current_liens[0].steps"
                :key="'current_lien' + idx"
                class="step"
              >
                <div
                  v-if="!(step.id_workflow_step_type === 3 && step.usps_image)"
                  class="tag has-text-weight-bold is-rounded"
                  :class="[
                    step.is_bounce
                      ? 'is-danger'
                      : step.skip
                        ? 'is-danger'
                        : idx === 0 && !step.is_executed
                          ? 'is-warning'
                          : step.is_executed
                            ? 'is-success'
                            : (!step.is_executed &&
                              info.current_liens[0].steps[idx - 1].is_executed) ||
                              info.current_liens[0].steps[idx - 1]?.skip ||
                              info.current_liens[0].steps[idx - 1].is_executed
                              ? 'is-warning'
                              : 'has-background-grey-light',
                  ]"
                  :data-date="
                    step.execution_date_format
                      ? step.execution_date_format
                      : 'TBD'
                  "
                >
                  <i
                    v-if="idx === 0 && !step.is_executed"
                    class="far fa-clock"
                    aria-hidden="true"
                  />
                  <i
                    v-else-if="step.is_executed"
                    class="fas fa-check-circle"
                    aria-hidden="true"
                  />
                  <i
                    v-else-if="
                      !step.is_executed &&
                        info.current_liens[0].steps[idx - 1].is_executed
                    "
                    class="far fa-clock"
                    aria-hidden="true"
                  />
                  {{ getStepName(info, step) }}
                  <div
                    v-if="step.is_archived"
                    class="archive__flag"
                  >
                    <span>
                      A
                      <span class="custom__tooltip">
                        This workflow step is archived.
                      </span>
                    </span>
                  </div>
                  <div
                    v-if="
                      (role === roles.SUPER_ADMIN &&
                        (isResendVisible(step, idx) ||
                          isCompleteVisible(step, idx) ||
                          isMailgunVisible(step) ||
                          !isImageAddVisible(step, idx))) ||
                        isStepExecuted(step) ||
                        true
                    "
                    class="card-header-icon"
                  >
                    <div
                      class="dropdown"
                      :class="{ 'is-active': step.show_menu }"
                    >
                      <div class="dropdown-trigger">
                        <button
                          v-if="
                            !isVisibleForCsAdminAndManager ||
                              isMailgunVisible(step) || isLienSaleStepForAdminAndManager(step)
                          "
                          class="button is-white"
                          aria-haspopup="true"
                          aria-controls="dropdown-menu"
                          @click="step.show_menu = !step.show_menu"
                        >
                          <span class="icon is-small">
                            <i
                              class="fas fa-ellipsis-v"
                              aria-hidden="true"
                            />
                          </span>
                        </button>
                      </div>
                      <div
                        id="dropdown-menu-state"
                        class="dropdown-menu"
                        role="menu"
                      >
                        <div class="dropdown-content">
                          <button
                            v-if="isCompleteVisible(step, idx)"
                            class="dropdown-item"
                            @click="showCompleteModal(step, idx)"
                          >
                            Complete
                          </button>
                          <button
                            v-if="
                              !isStepExecuted(step) &&
                                !isVisibleForCsAdminAndManager
                            "
                            class="dropdown-item"
                            @click="showChangeExecutionDateModal(step, idx)"
                          >
                            Change execution date
                          </button>
                          <button
                            v-if="isShowAddDataBtn(step)"
                            class="dropdown-item"
                            @click="showAddDataModel(step, idx)"
                          >
                            Upload Document
                          </button>
                          <button
                            v-if="
                              isResendVisible(step, idx) &&
                                !isVisibleForCsAdminAndManager
                            "
                            class="dropdown-item"
                            @click="showResendEmailModal(step.uuid)"
                          >
                            Resend Email
                          </button>
                          <button
                            v-if="isMailgunVisible(step)"
                            class="dropdown-item"
                            @click="showMailgunData(step.mailgun_data)"
                          >
                            Email Provider Data
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="step.id_workflow_step_type === 3 && step.usps_image"
                  :data-date="
                    step.execution_date_format
                      ? step.execution_date_format
                      : 'TBD'
                  "
                  class="tag has-text-weight-bold is-rounded copy-button is-success"
                >
                  <i
                    v-if="idx === 0 && !step.is_executed"
                    class="far fa-clock"
                    aria-hidden="true"
                  />
                  <i
                    v-else-if="step.is_executed"
                    class="fas fa-check-circle"
                    aria-hidden="true"
                  />
                  <i
                    v-else-if="
                      !step.is_executed &&
                        info.current_liens[0].steps[idx - 1].is_executed
                    "
                    class="far fa-clock"
                    aria-hidden="true"
                  />
                  {{ getStepName(info, step) }}
                  <div
                    v-if="step.is_archived"
                    class="archive__flag"
                  >
                    <span>
                      A
                      <span class="custom__tooltip">
                        This workflow step is archived.
                      </span>
                    </span>
                  </div>
                  <div
                    v-if="
                      role === roles.SUPER_ADMIN && isImageAddVisible(step, idx)
                    "
                    class="card-header-icon"
                  >
                    <div
                      class="dropdown"
                      :class="{ 'is-active': step.show_menu }"
                    >
                      <div class="dropdown-trigger">
                        <button
                          class="button is-white"
                          aria-haspopup="true"
                          aria-controls="dropdown-menu"
                          @click="step.show_menu = !step.show_menu"
                        >
                          <span class="icon is-small">
                            <i
                              class="fas fa-ellipsis-v"
                              aria-hidden="true"
                            />
                          </span>
                        </button>
                      </div>
                      <div
                        id="dropdown-menu-state"
                        class="dropdown-menu"
                        role="menu"
                      >
                        <div class="dropdown-content">
                          <button
                            class="dropdown-item"
                            @click="showAddDataModel(step, idx)"
                          >
                            Add data
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="step.is_executed"
                  class="content"
                >
                  <span
                    v-if="step?.is_bounce"
                    data-tooltip="The email was bounced"
                    :class="first - tooltip"
                    class="has-tooltip-bottom has-tooltip-arrow skip"
                    style="color: #f00"
                  >X</span>
                  <span
                    v-else-if="
                      info.possible_step_list[step.id_workflow_step_type]
                        .name === 'USPS'
                    "
                  >
                    <a
                      v-if="!step.skip"
                      :class="idx === 0 ? 'first-tooltip' : ''"
                      class="has-tooltip-bottom has-tooltip-arrow"
                      @click.prevent.self
                    ><i class="fas fa-check" /></a>
                    <span
                      v-else
                      data-tooltip="Skipped due to a lack of information"
                      :class="idx === 0 ? 'first-tooltip' : ''"
                      class="has-tooltip-bottom has-tooltip-arrow skip"
                    >X</span>
                  </span>
                  <span
                    v-else-if="step.details && step.details.is_clicked === 0"
                  >
                    <a
                      v-if="!step.skip"
                      :data-tooltip="
                        step.details.message
                          ? step.details.message
                          : 'Tenant clicked on the payment link inside the notification'
                      "
                      class="has-tooltip-bottom has-tooltip-arrow"
                      @click.prevent.self
                    ><i class="fas fa-check-double" /></a>
                    <span
                      v-else
                      data-tooltip="Skipped due to a lack of information"
                      :class="idx === 0 ? 'first-tooltip' : ''"
                      class="has-tooltip-bottom has-tooltip-arrow skip"
                    >X</span>
                  </span>
                  <span
                    v-else-if="
                      info.possible_step_list[step.id_workflow_step_type]
                        .name === 'Email' ||
                        info.possible_step_list[step.id_workflow_step_type]
                          .name == 'ECM'
                    "
                  >
                    <a
                      v-if="!step.skip"
                      :class="idx === 0 ? 'first-tooltip' : ''"
                      :data-tooltip="
                        'Delivered in the mailbox on ' +
                          step.execution_date_format
                          ? step.execution_date_format
                          : 'TBD'
                      "
                      class="has-tooltip-bottom has-tooltip-arrow"
                      @click.prevent.self
                    ><i class="fas fa-check" /></a>
                    <span
                      v-else
                      data-tooltip="Skipped due to a lack of information"
                      :class="idx === 0 ? 'first-tooltip' : ''"
                      class="has-tooltip-bottom has-tooltip-arrow skip"
                    >X</span>
                  </span>
                  <span
                    v-else-if="
                      info.possible_step_list[step.id_workflow_step_type]
                        .name === 'SMS'
                    "
                  >
                    <a
                      v-if="!step.skip"
                      :class="idx === 0 ? 'first-tooltip' : ''"
                      :data-tooltip="
                        'Sent on ' + step.execution_date_format
                          ? step.execution_date_format
                          : 'TBD'
                      "
                      class="has-tooltip-bottom has-tooltip-arrow"
                      @click.prevent.self
                    ><i class="fas fa-check" /></a>
                    <span
                      v-else
                      data-tooltip="Skipped due to a lack of information"
                      :class="idx === 0 ? 'first-tooltip' : ''"
                      class="has-tooltip-bottom has-tooltip-arrow skip"
                    >X</span>
                  </span>
                </div>
              </div>
              <div class="step">
                <span
                  class="tag has-text-weight-bold is is-rounded"
                  :class="info.renter.status_done ? 'is-success' : 'is-warning'"
                >Auction</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div ref="address" class="lien-details-wrapper lien-wrapper">
        <h5 class="lien-details-wrapper-title">Addresses</h5>
        <div class="columns d-flex" v-if="info.current_liens[0]">
          <div class="table__header">
            <button class="button btn is-info">Add New Addresses</button>
          </div>
          <div class="lien__table">
            <vuetable
              ref="vuetable-address"
              :api-mode="false"
              :fields="addressFields"
              :data="addressTable"
              :css="css.table"
              track-by="id"
            >
              <template slot="isEditable" slot-scope="props">
                <div v-if="props.rowData.isEditable">
                  <a style="text-decoration: underline" href="#">Edit</a>
                </div>
              </template>
            </vuetable>
          </div>
        </div>
      </div> -->

      <div
        ref="holds"
        data-key="holds"
        class="lien-details-wrapper lien-wrapper"
      >
        <h5 class="lien-details-wrapper-title">
          Holds & Restarts
        </h5>
        <div
          v-if="info.current_liens[0]"
          class="columns d-flex"
        >
          <div class="flex space-x-2 table__header">
            <button
              v-if="hasPermission('place_hold')"
              class="button primary ml-0"
              @click="showHoldsAddModal"
            >
              Add Hold
            </button>
            <button
              v-if="hasPermission('place_hold')"
              class="button primary ml-0"
              :disabled="(holdsRestartSteps && !Object.values(holdsRestartSteps)?.length) || !holdsRestartSteps"
              @click="requestRestartDialog = true"
            >
              Request Restart
            </button>
          </div>
          <div class="lien__table overflow-x-scroll rounded border border-muted-300 dark:border-muted-600">
            <vuetable
              ref="vuetable-holds"
              :api-mode="false"
              :fields="holdFields"
              :data="holdTable"
              :css="css.table"
              track-by="id"
            >
              <template
                slot="id"
                slot-scope="props"
              >
                <p>#{{ props.rowData.id }}</p>
              </template>
              <template
                slot="isEditable"
                slot-scope="props"
              >
                <div v-if="hasPermission('request_hold', 'release_hold') && props.rowData.status !== 'Released'">
                  <a
                    style="text-decoration: underline"
                    href="#"
                    @click="() => showHoldsViewModal(props.rowData.id)"
                  >View/Edit</a>
                </div>
                <div v-else>
                  <a
                    style="text-decoration: underline"
                    href="#"
                    @click="() => showHoldsViewModal(props.rowData.id)"
                  >View</a>
                </div>
              </template>
              <template
                slot="date_created"
                slot-scope="props"
              >
                <div v-if="props.rowData.date_created">
                  {{ formatDate(props.rowData.date_created) }}
                </div>
                <div v-else>
                  -
                </div>
              </template>
              <template
                slot="release_date"
                slot-scope="props"
              >
                <div v-if="props.rowData.release_date">
                  {{ formatDate(props.rowData.release_date) }}
                </div>
                <div v-else>
                  -
                </div>
              </template>
            </vuetable>
          </div>
        </div>
      </div>
      <div
        ref="lienHistory"
        class="lien-details-wrapper lien-wrapper"
      >
        <h5 class="lien-details-wrapper-title">
          AI-Lean Lien History
        </h5>
        <div
          v-if="info.current_liens[0]"
          class="columns d-flex"
        >
          <div
            class="lien__table overflow-x-scroll rounded border border-muted-300 dark:border-muted-600 mt-5"
          >
            <vuetable
              ref="vuetable-lien-history"
              :api-mode="false"
              :fields="lienHistoryFields"
              :data="lienHistoryData"
              :css="css.table"
              track-by="uuid"
            >
              <template
                slot="id_renter"
                slot-scope="props"
              >
                <button
                  style="text-decoration: underline"
                  @click="(() => historyRenterLinkNavigator(props.rowData.uuid))"
                >
                  {{ props.rowData.id_renter }}
                </button>
              </template>
              <template
                slot="discontinued_date"
                slot-scope="props"
              >
                <span>{{ props.rowData.discontinued_date ?? '-' }}</span>
              </template>
              <template
                slot="delinquency_days"
                slot-scope="props"
              >
                <span>{{ props.rowData.delinquency_days ?? '-' }}</span>
              </template>
              <template
                slot="discontinued_stage"
                slot-scope="props"
              >
                <span>{{ props.rowData.discontinued_stage ?? '-' }}</span>
              </template>
              <template
                slot="discontinue_reason"
                slot-scope="props"
              >
                {{ props.rowData.discontinue_reason ?? '-' }}
              </template>
            </vuetable>
          </div>
        </div>
      </div>
      <div
        ref="document"
        class="lien-details-wrapper lien-wrapper lien-document-wrap"
      >
        <h5 class="lien-details-wrapper-title">
          Document Vault
        </h5>
        <div
          v-if="info.current_liens[0]"
          class="columns d-flex"
        >
          <div class="table__header flex flex-col sm:flex-row">
            <p>View Documents:</p>
            <div class="tabs is-toggle is-toggle-rounded">
              <ul>
                <li
                  v-for="tab in documentVaultTabs"
                  :key="tab.id"
                  :class="tab.isActive ? 'is-active' : ''"
                  @click="() => handleDocumentVaultTabs(tab.id)"
                >
                  <a>
                    <span>
                      {{ tab.title }}
                    </span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div
            class="lien__table"
            style="padding-top: 20px"
          >
            <div class="lien__files space-y-4 dark:text-white">
              <div
                v-for="(item,i) in files"
                :key="i"
                class="lien__file border-t first:border-0 border-gray-600"
              >
                <div
                  v-if="!item.document?.length"
                  class="mb-4"
                >
                  <p>
                    {{ item.step }} {{ item.date }}
                    <br>
                    <span>
                      No File Found
                    </span>
                  </p>
                </div>
                <div
                  v-if="isImage(item.document)"
                  class="my-4"
                >
                  <p>
                    {{ item.step }} {{ item.date }}
                  </p>
                  <img
                    :src="item.document"
                    alt=""
                    class="summary__imgs w-full my-2.5 object-contain block"
                  >
                </div>
                <div
                  v-if="isPdf(item.document)"
                  class="my-4"
                >
                  <p>
                    {{ item.step }} {{ item.date }}
                  </p>
                  <div class="flex justify-end">
                    <!-- @todo no sense to show this btn, because default viewer already have it -->
                    <!-- <a
                      class="button primary-light my-2.5"
                      :href="item.document"
                    >Download pdf</a> -->
                  </div>
                  <iframe
                    class="summary__imgs invisibleOnPrint bg-white rounded-md shadow-md p-4"
                    style="
                      width: 100%;
                      height: 900px;
                      margin: 10px 0;
                      object-fit: contain;
                    "
                    :src="item.document"
                  />
                </div>
                <div
                  v-if="item.type === 'html'"
                  class="mb-4 mt-4"
                >
                  <div class="flex justify-between items-center">
                    <p>
                      {{ item.step }} <br>
                      <small>{{ item.date }}</small>
                    </p>
                    <button
                      class="button primary my-2.5"
                      @click="printLetter(item.id_lien_task)"
                    >
                      Print
                    </button>
                  </div>
                  <div
                    :ref="`letter-${item.id_lien_task}`"
                    class="bg-white text-muted-950 dark:bg-muted-100 p-4 rounded-md shadow-md"
                    v-html="item.document"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div
        ref="analytics"
        class="lien-details-wrapper lien-wrapper lien-document-wrap"
      >
        <h5 class="lien-details-wrapper-title">Analytics</h5>
      </div> -->
      <div
        ref="historyUpdates"
        class="lien-details-wrapper lien-wrapper lien-document-wrap"
      >
        <h5 class="lien-details-wrapper-title">
          Activity Logs
        </h5>
        <div
          class="overflow-scroll max-h-screen"
        >
          <template v-if="activities?.length">
            <div
              v-for="(log, i) in activities"
              :key="i"
              class="bg-white dark:bg-muted-800 shadow-sm px-4 py-2 rounded border border-muted-300 dark:border-muted-600 mb-2"
            >
              <div class="flex flex-col md:flex-row md:justify-between text-sm text-muted-800 dark:text-muted-200">
                <div>
                  {{ convertHoldAction(log.slug) ?? '-' }} by
                  <strong>{{ log.email ?? '-' }}</strong>
                </div>
                <div>
                  {{ log.date ?? '-' }}
                </div>
              </div>
              <div class="border-t border-dashed dark:border-muted-700 mt-2 pt-2">
                {{ log.notes ?? '-' }}
              </div>
            </div>
          </template>
          <p v-else>
            No Data
          </p>
        </div>
      </div>
      <div
        class="modal"
        :class="{ 'is-active': show_modal }"
      >
        <div
          class="modal-background"
          @click="hideAddModal()"
        />
        <div class="modal-content">
          <div
            v-if="showAddImageModal"
            class="box"
          >
            <div>
              <h6>
                {{ info.renter.base64_image ? "Change" : "Add" }} an image
              </h6>
              <div class="field">
                <div class="control">
                  <label class="label">Description</label>
                  <textarea
                    ref="description"
                    class="input is-mandatory"
                    name="description"
                    :class="errors.description.visible ? 'has-error' : ''"
                    placeholder="Add a description..."
                  />
                  <span v-if="errors.description.visible">{{
                    errors.description.message
                  }}</span>
                </div>
              </div>
              <div class="upload-image">
                <input
                  v-if="showUploader"
                  id="file-input"
                  ref="uploadInput"
                  type="file"
                  accept="image/*"
                  class="button is-outlined file-uploader"
                  @change="uploadImage"
                >
                <button
                  v-else
                  class="button is-white change-image"
                  @click="handleChangePhoto()"
                >
                  Change photo
                </button>
                <img
                  v-if="image"
                  :src="image"
                  alt="img"
                  class="image-preview"
                >
              </div>
            </div>
            <p class="control has-text-right">
              <a
                href="#"
                class="button is-white"
                @click="hideAddModal()"
              >Cancel</a>
              <a
                href="#"
                class="button primary is-outlined"
                @click="handleAddClick()"
              >{{ info.renter.base64_image ? "Save" : "Add" }}</a>
            </p>
          </div>
          <div
            v-else
            class="box edit"
          >
            <div class="view-image">
              <h6>View</h6>
              <p
                v-if="info.renter.image_description"
                class="image-description"
              >
                <b>Description:</b> {{ info.renter.image_description }}
              </p>
              <img
                :src="info.renter.base64_image"
                alt="img"
                class="image-preview"
              >
            </div>
            <p class="control has-text-right">
              <button
                type="button"
                class="button is-white"
                @click="hideAddModal()"
              >
                Cancel
              </button>
              <button
                type="button"
                class="button primary is-outlined"
                @click="handleEditClick()"
              >
                Edit
              </button>
            </p>
          </div>
        </div>
        <button
          class="modal-close is-large"
          aria-label="close"
          @click="hideAddModal()"
        />
      </div>
      <div
        class="modal"
        :class="{ 'is-active': show_modal2 }"
      >
        <div
          class="modal-background"
          @click="hideAddModal()"
        />
        <div class="modal-content">
          <div class="box">
            <div>
              <h6>Add an image / Pdf</h6>
              <div class="field">
                <div class="control">
                  <label class="label">Description</label>
                  <textarea
                    ref="description2"
                    v-model="description2"
                    class="input is-mandatory"
                    name="description"
                    :class="errors.description2.visible ? 'has-error' : ''"
                    placeholder="Add a description..."
                  />
                  <span v-if="errors.description2.visible">{{
                    errors.description2.message
                  }}</span>
                </div>
              </div>
              <div class="upload-image">
                <input
                  id="file-input2"
                  ref="uploadInput"
                  type="file"
                  accept="image/*, application/pdf"
                  class="button is-outlined file-uploader"
                  multiple
                  @change="uploadImage"
                >
                <div
                  v-for="(image, index) in imagesPfs"
                  :key="image.id"
                  style="margin-top: 10px"
                >
                  <div
                    v-if="image.mime && image.mime !== 'pdf'"
                    style="
                      margin: 5px 5px 5px 0;
                      display: flex;
                      align-items: center;
                    "
                  >
                    <img
                      :src="image.path"
                      alt="img"
                      class="image-preview"
                      style="margin-right: 10px"
                    >
                    <span
                      class="icon"
                      style="cursor: pointer"
                      @click="deleteImage(image, index)"
                    ><i
                      class="fas fa-times"
                      aria-hidden="true"
                    /></span>
                  </div>
                  <div
                    v-if="image.mime === 'pdf'"
                    style="
                      margin: 5px 5px 5px 0;
                      display: flex;
                      align-items: center;
                    "
                  >
                    <a
                      class="button primary-light"
                      :href="image.path"
                    >Download pdf</a>
                    <span
                      class="icon"
                      style="cursor: pointer"
                      @click="deleteImage(image, index)"
                    ><i
                      class="fas fa-times"
                      aria-hidden="true"
                    /></span>
                  </div>
                  <div
                    v-if="!image.mime"
                    class="not_uploaded bg-muted-200 dark:bg-muted-600"
                  >
                    {{ image.name }} - Not uploaded
                    <span
                      class="icon"
                      style="cursor: pointer"
                      @click="deleteImage(image, index)"
                    ><i
                      class="fas fa-times"
                      aria-hidden="true"
                    /></span>
                  </div>
                </div>
                <img
                  v-if="image_lien_task && image_lien_task !== 'false'"
                  :src="image_lien_task"
                  alt="img"
                  class="image-preview"
                  style="margin-right: 10px"
                >
                <a
                  v-if="!showUploaderPdf"
                  class="button primary-light"
                  :href="pdfFile"
                >Download pdf</a>
              </div>
            </div>
            <p class="control has-text-right">
              <a
                href="#"
                class="button is-white mr-1"
                @click="hideAddDataModel()"
              >Cancel</a>
              <a
                href="#"
                :class="` ${
                  fileLoader
                    ? 'is-loading button primary'
                    : 'button primary'
                } `"
                @click="handleAddClickManual()"
              >{{ image_lien_task ? "Save" : "Add" }}</a>
            </p>
          </div>
        </div>
        <button
          class="modal-close is-large"
          aria-label="close"
          @click="hideAddDataModel()"
        />
      </div>
      <div
        class="modal complete-modal"
        :class="{ 'is-active': show_complete_modal }"
      >
        <div
          class="modal-background"
          @click="hideCompleteModal"
        />
        <div class="modal-content">
          <div class="box">
            <h5>Complete step</h5>
            <div class="complete-date-picker">
              <vc-date-picker
                v-model="completeDate"
                :is-dark="isDark"
                :max-date="completeDateConfig.maxDate"
                :min-date="completeDateConfig.minDate"
              />
            </div>
            <div
              class="control has-text-right"
              style="margin-top: 2rem"
            >
              <button
                class="button is-white"
                @click="hideCompleteModal"
              >
                Cancel
              </button>
              <button
                class="button primary is-outlined"
                :disabled="!completeDate"
                @click="handleCompleteClick"
              >
                Complete
              </button>
            </div>
          </div>
        </div>
        <button
          class="modal-close is-large"
          aria-label="close"
          @click="hideCompleteModal"
        />
      </div>
      <div
        class="modal complete-modal"
        :class="{ 'is-active': show_change_execution_modal }"
      >
        <div
          class="modal-background"
          @click="hideChangeExecutionDateModal"
        />
        <div class="modal-content">
          <div class="box">
            <h5>Change step execution date</h5>
            <div class="complete-date-picker">
              <vc-date-picker
                v-model="completeExecutionDate"
                :is-dark="isDark"
              />
            </div>
            <div
              class="control has-text-right"
              style="margin-top: 2rem"
            >
              <button
                class="button is-white"
                @click="hideChangeExecutionDateModal"
              >
                Cancel
              </button>
              <button
                class="button primary is-outlined"
                :disabled="!completeExecutionDate"
                @click="handleCompleteChangeClick"
              >
                Change date
              </button>
            </div>
          </div>
        </div>
        <button
          class="modal-close is-large"
          aria-label="close"
          @click="hideCompleteModal"
        />
      </div>
      <div
        class="modal resend-email-modal"
        :class="{ 'is-active': show_resend_email_modal }"
      >
        <div
          class="modal-background"
          @click="hideResendEmailModal"
        />
        <div class="modal-content">
          <div class="box">
            <h5>Resend email</h5>
            <div
              class="control has-text-right"
              style="margin-top: 2rem"
            >
              <button
                class="button is-white"
                @click="hideResendEmailModal"
              >
                Cancel
              </button>
              <button
                :class="
                  resendEmailLoading
                    ? 'button primary is-loading'
                    : 'button primary is-outlined'
                "
                @click="handleResendEmailClick"
              >
                Resend
              </button>
            </div>
          </div>
        </div>
        <button
          class="modal-close is-large"
          aria-label="close"
          @click="hideResendEmailModal"
        />
      </div>
      <div
        class="modal resend-email-modal"
        :class="{ 'is-active': show_mailgun_modal }"
      >
        <div
          class="modal-background"
          @click="hideMailgunModal"
        />
        <div class="modal-content">
          <div class="box">
            <h5>Email Provider Data</h5>
            <div
              class="control"
              style="margin-top: 2rem"
            >
              <pre>{{ JSON.stringify(JSON.parse(mailgun_data), null, 2) }}</pre>
            </div>
          </div>
        </div>
        <button
          class="modal-close is-large"
          aria-label="close"
          @click="hideMailgunModal"
        />
      </div>
      <div
        class="modal add-description"
        :class="{ 'is-active': show_add_edit_description_modal }"
      >
        <div
          class="modal-background"
          @click="hideAddEditDescriptionModal()"
        />
        <div class="modal-content">
          <div class="box">
            <div>
              <h6>{{ getTenantDescription() ? "Edit" : "Add" }} description</h6>
              <div class="field">
                <div class="control">
                  <label class="label">Description</label>
                  <textarea
                    ref="tenantDescription"
                    class="input is-mandatory"
                    name="tenantDescription"
                    :class="errors.tenantDescription.visible ? 'has-error' : ''"
                    placeholder="Add a description..."
                  />
                  <span v-if="errors.tenantDescription.visible">{{
                    errors.tenantDescription.message
                  }}</span>
                </div>
              </div>
            </div>
            <div class="control modal-footer">
              <button
                type="button"
                class="button is-white"
                @click="hideAddEditDescriptionModal()"
              >
                Cancel
              </button>
              <button
                type="button"
                class="button primary is-outlined"
                @click="handleDescriptionSave()"
              >
                {{ getTenantDescription() ? "Save" : "Add" }}
              </button>
            </div>
          </div>
        </div>
        <button
          class="modal-close is-large"
          aria-label="close"
          @click="hideAddEditDescriptionModal()"
        />
      </div>
      <div
        class="modal usps-image-modal"
        :class="{ 'is-active': show_usps_image_modal }"
      >
        <div
          class="modal-background"
          @click="hideUspsImageModal()"
        />
        <div class="modal-content">
          <div class="box">
            <h5>USPS Image</h5>
            <div class="usps-image">
              <img
                v-if="uspsImage"
                :src="uspsImage"
                alt="img"
                class="image-preview"
              >
            </div>
            <div
              class="control has-text-right"
              style="margin-top: 2rem"
            >
              <button
                class="button is-white"
                @click="hideUspsImageModal()"
              >
                Close
              </button>
            </div>
          </div>
        </div>
        <button
          class="modal-close is-large"
          aria-label="close"
          @click="hideUspsImageModal()"
        />
      </div>
      <div
        class="modal"
        :class="{ 'is-active': showDiscontine }"
      >
        <div
          class="modal-background"
          @click="hideDiscontinueModal()"
        />
        <div class="modal-content">
          <div class="box">
            <div class="field">
              <div class="control">
                <label class="label">Reason</label>
                <textarea
                  ref="reason"
                  class="input is-mandatory"
                  name="reason"
                  placeholder="Add a reason..."
                />
                <span v-if="errors.reason.visible">{{
                  errors.reason.message
                }}</span>
              </div>
            </div>
            <div class="btn-groups">
              <button
                class="button is-warning is-white change-image btn"
                style="margin-left: auto"
                @click="hideDiscontinueModal()"
              >
                Cancel
              </button>
              <button
                class="button is-white change-image btn"
                @click="handleDiscontinueBtn()"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
        <button
          class="modal-close is-large"
          aria-label="close"
          @click="hideDiscontinueModal()"
        >
          close
        </button>
      </div>
      <div
        class="modal"
        style="z-index: 999"
        :class="{ 'is-active': isApproveModalOpen }"
      >
        <div
          class="modal-background"
          @click="hideApproveModal()"
        />
        <div
          class="modal-content"
          style="max-width: 800px; overflow: unset"
        >
          <div
            class="box"
            style="min-height: 200px"
          >
            <p class="subtitle">
              By clicking yes you confirm that the unit was auctioned. This
              action cannot be undone. Are you sure you want to proceed.
            </p>

            <div class="control has-text-right">
              <button
                type="button"
                class="button is-white"
                @click="hideApproveModal()"
              >
                No
              </button>
              <button
                type="button"
                class="button primary is-outlined"
                @click="approveFinalButton"
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        class="modal"
        style="z-index: 999"
        :class="{ 'is-active': isAddHolds }"
      >
        <div
          class="modal-background"
          @click="hideHoldsAddModal()"
        />
        <div
          class="modal-content"
          style="max-width: 800px; overflow: unset"
        >
          <form
            class="box"
            style="min-height: 435px"
            @submit="createHold"
          >
            <p class="modal-title">
              Add New Hold
            </p>
            <div
              class="border border-muted-300 dark:border-muted-600 mb-10 mt-2"
            />
            <div class="field">
              <div class="control">
                <label class="label">Hold Category</label>
                <div class="select is-fullwidth">
                  <div class="select-container">
                    <select
                      v-model="holdCategory"
                      required
                    >
                      <option
                        selected
                        disabled
                        hidden
                        value=""
                      >
                        Select Hold Category ...
                      </option>
                      <option
                        v-for="(hold, key) in holdList"
                        :key="key"
                        :value="key"
                      >
                        {{ hold.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="field">
              <div class="control">
                <label class="label">Hold Description</label>
                <textarea
                  v-model="holdDescription"
                  class="input is-mandatory"
                  name="description"
                  maxlength="8000"
                  minlength="6"
                  required
                  placeholder="Add a description..."
                />
              </div>
            </div>

            <div class="control has-text-right modal-btns">
              <button
                type="button"
                class="button is-white"
                @click="hideHoldsAddModal()"
              >
                Cancel
              </button>
              <button
                type="submit"
                class="button primary is-outlined ml-2"
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
      <div
        class="modal"
        style="z-index: 999"
        :class="{ 'is-active': isViewHolds }"
      >
        <div
          class="modal-background"
          @click="hideHoldsViewModal()"
        />
        <div
          v-if="isHoldViewLoading"
          class="loader"
        />
        <div
          v-if="!isHoldViewLoading"
          class="modal-content hold-details-dialog"
          style="overflow: unset"
        >
          <div
            class="box"
            style="min-height: 400px; display: block"
          >
            <div class="modal-title flex justify-between items-center ">
              Hold Details

              <button
                class="button is-white is-pulled-right"
                @click="hideHoldsViewModal()"
              >
                <i class="fas fa-times" />
              </button>
            </div>
            <div
              class="border border-muted-300 dark:border-muted-600 mb-10 mt-2"
            />
            <div class="modal__content">
              <div class="content__row">
                <div class="content__label">
                  Status
                </div>
                <div class="content__value">
                  {{ selectedHoldForView.hold?.status }}
                </div>
              </div>
              <div class="content__row">
                <div class="content__label">
                  Hold Category
                </div>
                <div class="content__value">
                  {{ selectedHoldForView.hold?.category }}
                </div>
              </div>
              <div class="content__row">
                <div class="content__label">
                  Hold Start Date
                </div>
                <div class="content__value">
                  {{
                    selectedHoldForView.hold?.date_created
                      ? formatDate(selectedHoldForView.hold?.date_created, 'full')
                      : "-"
                  }}
                </div>
              </div>
              <div class="content__row">
                <div class="content__label">
                  Release Date
                </div>
                <div class="content__value">
                  {{ holdRelease_date }}
                </div>
              </div>
              <div class="content__desc">
                <div class="content__label">
                  Hold Description
                </div>
                <div class="content__value">
                  {{ selectedHoldForView.hold?.description }}
                </div>
              </div>
              <div class="content__updates">
                <h6 class="content__subtitle mb-2">
                  Updates
                </h6>
                <template v-if="selectedHoldForView.activity?.length">
                  <div
                    v-for="(log, i) in selectedHoldForView.activity"
                    :key="i"
                    class="bg-white dark:bg-muted-700 shadow-sm px-2 py-2 mb-2 rounded border border-muted-300 dark:border-muted-600"
                  >
                    <div class="flex flex-col md:flex-row md:justify-between text-sm text-muted-800 dark:text-muted-200">
                      <div>
                        {{ convertHoldAction(log.type) ?? '-' }} by
                        <strong>{{ log.user ?? '-' }}</strong>
                      </div>
                      <div>
                        {{ log.date ?? '-' }}
                      </div>
                    </div>
                    <div class="border-t border-dashed border-gray-400 mt-2 pt-2">
                      {{ log.description ?? '-' }}
                    </div>
                  </div>
                </template>
              </div>
            </div>
            <div
              v-if="hasPermission('request_hold') && selectedHoldForView.hold?.status == 'Active'"
              class="request__release"
            >
              <p class="modal-title">
                Request Release
              </p>
              <div
                class="border"
                style="margin-bottom: 35px"
              />
              <div class="field">
                <div class="control">
                  <label class="label">Comments</label>
                  <textarea
                    v-model="requestHoldNote"
                    class="input is-mandatory"
                    name="description"
                    required
                    placeholder="Add comments ..."
                  />
                  <p
                    v-if="
                      isInvalidTextareaNote(requestHoldNote) &&
                        requestHoldNote.length
                    "
                    style="color: #f44336; margin-top: 8px"
                  >
                    Please enter a comment between 6 and 8000 characters.
                  </p>
                </div>
              </div>
              <div class="field">
                <div class="control">
                  <label
                    style="width: 350px"
                    class="label"
                  >Restart Step</label>
                  <div class="select is-fullwidth">
                    <div class="select-container">
                      <select
                        ref="requestRelease"
                        :disabled="
                          !Object.keys(selectedHoldForView.restart_stages)
                            .length
                        "
                        required
                      >
                        <option
                          selected
                          value=""
                        >
                          No Restart
                        </option>
                        <option
                          v-for="(
                            item, index
                          ) in selectedHoldForView.restart_stages"
                          :key="index"
                          :value="index"
                        >
                          {{ item.type }}:
                          {{ item.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="hasPermission('release_hold') && selectedHoldForView.hold?.status == 'Pending Release'"
              class="ai-lean__release"
            >
              <p class="modal-title">
                AI-Lean Release
              </p>
              <div
                class="border"
                style="margin-bottom: 35px"
              />
              <div class="field">
                <div class="control">
                  <label class="label">Comments</label>
                  <textarea
                    v-model="releaseHoldNote"
                    class="input is-mandatory"
                    name="description"
                    required
                    placeholder="Add comment ..."
                  />
                  <p
                    v-if="
                      isInvalidTextareaNote(releaseHoldNote) &&
                        releaseHoldNote.length
                    "
                    style="color: #f44336; margin-top: 8px"
                  >
                    Please enter a comment between 6 and 8000 characters.
                  </p>
                </div>
              </div>
              <div class="field">
                <div class="control">
                  <label
                    style="width: 350px"
                    class="label"
                  >Restart Step</label>
                  <div class="select is-fullwidth">
                    <div class="select-container">
                      <select
                        ref="aILeanRelease"
                        v-model="aILeanReleaseModel"
                        :disabled="
                          !Object.keys(selectedHoldForView.restart_stages)
                            .length
                        "
                        required
                      >
                        <option
                          selected
                          value=""
                        >
                          No Restart
                        </option>
                        <option
                          v-for="(
                            item, index
                          ) in selectedHoldForView.restart_stages"
                          :key="index"
                          :value="index"
                        >
                          {{ item.type }}:
                          {{ item.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="control has-text-right modal-btns">
              <button
                type="button"
                class="button is-white mr-2"
                @click="hideHoldsViewModal()"
              >
                Cancel
              </button>
              <button
                v-if="
                  selectedHoldForView.hold?.status == 'Pending Release' &&
                    role === roles.SUPER_ADMIN
                "
                type="button"
                style="margin-right: 8px"
                :class="
                  isRejectHoldLoading
                    ? 'button primary is-loading'
                    : 'button primary is-outlined'
                "
                @click="rejectHoldRelease"
              >
                Reject
              </button>
              <button
                v-if="
                  selectedHoldForView.hold?.status == 'Pending Release' &&
                    role === roles.SUPER_ADMIN
                "
                type="button"
                style="margin-right: 8px"
                :class="
                  isReleaseHoldLoading
                    ? 'button primary is-loading'
                    : 'button primary is-outlined'
                "
                @click="approveHoldRelease"
              >
                Release
              </button>
              <button
                v-if="selectedHoldForView.hold?.status == 'Active' && hasPermission('request_hold')"
                type="button"
                style="margin-right: 8px"
                :class="
                  isRequestHoldLoading
                    ? 'button primary is-loading'
                    : 'button primary is-outlined'
                "
                @click="requestHoldRelease"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        class="modal"
        style="z-index: 9999"
        :class="{ 'is-active': isViewHoldsConfirm }"
      >
        <div
          class="modal-background"
        />

        <div
          class="modal-content w-80 bg-muted-50 dark:bg-muted-800 p-5 pt-3 rounded flex flex-col justify-between"
        >
          <div>
            <h5>Caution!</h5>
            <p class="text-sm">
              The lien has been restarted and new step(s) have been added to its workflow.
            </p>
            <p class="text-sm">
              Double check their planned execution date.
            </p>
          </div>

          <button
            class="mt-3 bg-primary py-2 rounded dark:text-white text-foreground"
            @click="releaseCautionHandler()"
          >
            OK
          </button>
        </div>
      </div>

      <div
        class="modal"
        style="z-index: 9999"
        :class="{ 'is-active': requestRestartDialog }"
      >
        <div
          class="modal-background"
          @click="requestRestartDialog = false"
        />

        <form
          class="modal-content bg-muted-50 dark:bg-muted-800 p-5 pt-3 rounded flex flex-col justify-between"
          @submit.prevent="requestHoldRestartHandler"
        >
          <div>
            <h5 class="border-b-2 pb-4">
              Request Restart
            </h5>
            <div class="field">
              <div class="control">
                <label class="label">Comments</label>
                <textarea
                  ref="requestRestartHoldNote"
                  v-model="requestHoldNote"
                  class="input is-mandatory"
                  name="description"
                  required
                  placeholder="Add comments ..."
                />
                <p
                  v-if="
                    isInvalidTextareaNote(requestHoldNote) &&
                      requestHoldNote.length
                  "
                  style="color: #f44336; margin-top: 8px"
                >
                  Please enter a comment between 6 and 8000 characters.
                </p>
              </div>
            </div>
            <div class="field">
              <div class="control">
                <label
                  style="width: 350px"
                  class="label"
                >Restart Step</label>
                <div class="select is-fullwidth">
                  <div class="select-container">
                    <select
                      ref="requestRelease"
                      :disabled="(holdsRestartSteps &&
                        !Object.keys(holdsRestartSteps)
                          .length) || !holdsRestartSteps
                      "
                      required
                    >
                      <option
                        v-for="(
                          item, index
                        ) in holdsRestartSteps"
                        :key="index"
                        :value="index"
                      >
                        {{ item.type }}:
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="flex justify-end space-x-2">
            <button
              class="mt-3 text-gray-500 py-2 px-4 rounded hover:text-primary transition-colors"
              :disabled="requestRestartDialogLoading"
              @click="requestRestartDialog = false"
            >
              Cancel
            </button>
            <button
              type="submit"
              class="mt-3 border border-primary font-medium hover:bg-primary hover:text-white transition-colors py-2 px-4 rounded text-primary"
              :disabled="requestRestartDialogLoading"
              @click="requestHoldRestartHandler()"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </section>
  </div>
</template>
<script>
import Vue from 'vue';
import VueHtmlToPaper from 'vue-html-to-paper';
import Vuetable from 'vuetable-2/src/components/Vuetable';
// eslint-disable-next-line import/no-extraneous-dependencies
import moment from 'moment';
// import { useThrottleFn } from '@vueuse/core';

import AuthService from '../../services/auth.service';
import UserService from '../../services/user.service';
import DashboardService from '../../services/dashboard.service';
import { formatCurrency } from '../../utils/stringUtils';
import { isImage, isPdf, isValidSize } from '../../utils/validationUtils';
import { Roles, tableConfig } from '../../constants';
import store from '../../store';

import debounce from '@/utils/debounceUtil';
import throttle from '@/utils/throttleUtil';

const htmlPaperOptions = {
  name: '_blank',
  styles: ['/print.css']
};
const authService = new AuthService();
const userService = new UserService();
const dashboardService = new DashboardService();
Vue.use(VueHtmlToPaper, htmlPaperOptions);
const defaultErrors = {
  description: {
    visible: false,
    message: ''
  },
  description2: {
    visible: false,
    message: ''
  },
  tenantDescription: {
    visible: false,
    message: ''
  },
  reason: {
    visible: false,
    message: ''
  }
};

export default {
  name: 'TenantDetails',
  components: {
    Vuetable
  },
  data() {
    return {
      auctionDialog: false,
      navLinks: [
        {
          name: 'Lien Details',
          id: 1,
          key: 'lienDetails',
          isActive: true
        },
        {
          name: 'Workflow Progress',
          id: 2,
          key: 'workflow',
          isActive: false
        },
        {
          name: 'Holds',
          id: 4,
          key: 'holds',
          isActive: false
        },
        {
          name: 'AI-Lean Lien History',
          id: 5,
          key: 'lienHistory',
          isActive: false
        },
        {
          name: 'Document Vault',
          id: 6,
          key: 'document',
          isActive: false
        },
        // {
        //   name: 'Analytics',
        //   id: 7,
        //   key: 'analytics',
        //   isActive: false
        // },
        {
          name: 'Activity Logs',
          id: 8,
          key: 'historyUpdates',
          isActive: false
        }
      ],
      documentVaultTabs: [
        {
          title: 'Active',
          id: 1,
          key: 'active',
          isActive: true
        },
        {
          title: 'Archive',
          id: 2,
          key: 'archive',
          isActive: false
        },
        {
          title: 'All',
          id: 3,
          key: 'all',
          isActive: false
        }
      ],
      css: {
        table: tableConfig
      },
      addressFields: [
        {
          title: 'Address',
          name: 'address',
          titleClass: 'subttile2'
        },
        {
          title: 'Tupe',
          name: 'tupe',
          titleClass: 'subttile2'
        },
        {
          title: 'Source',
          name: 'source',
          titleClass: 'subttile2'
        },
        {
          title: 'Source',
          name: 'source',
          titleClass: 'subttile2'
        },
        {
          title: '',
          name: '__slot:isEditable',
          titleClass: 'subttile2'
        }
      ],
      addressTable: [
        {
          id: 1,
          address:
            'Robert Robertson, 1234 NW Bobcat Lane, St. Robert, MO 65584-5678',
          tupe: 'Primary',
          source: 'system',
          isEditable: false
        },
        {
          id: 2,
          address:
            'Robert Robertson, 1234 NW Bobcat Lane, St. Robert, MO 65584-5678',
          tupe: 'Alternate',
          source: 'manual',
          isEditable: false
        },
        {
          id: 3,
          address:
            'Robert Robertson, 1234 NW Bobcat Lane, St. Robert, MO 65584-5678',
          tupe: 'Alternate',
          source: 'system',
          isEditable: true
        },
        {
          id: 4,
          address:
            'Robert Robertson, 1234 NW Bobcat Lane, St. Robert, MO 65584-5678',
          tupe: 'Alternate',
          source: 'manual',
          isEditable: true
        }
      ],
      holdFields: [
        {
          title: 'Hold ID',
          name: '__slot:id',
          titleClass: 'subttile2'
        },
        {
          title: 'Category',
          name: 'category',
          titleClass: 'subttile2'
        },
        {
          title: 'Requested Date',
          name: '__slot:date_created',
          titleClass: 'subttile2'
        },
        {
          title: 'Release Date',
          name: '__slot:release_date',
          titleClass: 'subttile2'
        },
        {
          title: 'Description',
          name: 'description',
          titleClass: 'subttile2'
        },
        {
          title: 'Status',
          name: 'status',
          titleClass: 'subttile2'
        },
        {
          title: '',
          name: '__slot:isEditable',
          titleClass: 'subttile2'
        }
      ],
      holdTable: [],
      lienHistoryFields: [
        {
          title: 'Lien ID',
          name: '__slot:id_renter',
          titleClass: 'subttile2'
        },
        {
          title: 'Start Date',
          name: 'start_date',
          titleClass: 'subttile2'
        },
        {
          title: 'Discontinued Date',
          name: '__slot:discontinued_date',
          titleClass: 'subttile2'
        },
        {
          title: 'Delinquency Days',
          name: '__slot:delinquency_days',
          titleClass: 'subttile2'
        },
        {
          title: 'Discontinued Stage',
          name: '__slot:discontinued_stage',
          titleClass: 'subttile2'
        },
        {
          title: 'Discontinuation Reason',
          name: '__slot:discontinue_reason',
          titleClass: 'subttile2'
        }
      ],
      lienHistoryData: [
        {
          id: 1,
          lien_id: 'AL-98776',
          days: '23',
          start_date: '06/09/2023',
          discontinued_date: '06/09/2023',
          discontinued_stage: 'Early notification',
          reason: 'Paid'
        },
        {
          id: 2,
          lien_id: 'AL-32452',
          days: '23',
          start_date: '06/09/2023',
          discontinued_date: '06/09/2023',
          discontinued_stage: 'Early notification',
          reason: 'Paid'
        },
        {
          id: 3,
          lien_id: 'AL-3452',
          days: '23',
          start_date: '06/09/2023',
          discontinued_date: '06/09/2023',
          discontinued_stage: 'Early notification',
          reason: 'Paid'
        },
        {
          id: 4,
          lien_id: 'AL-12452',
          days: '23',
          start_date: '06/09/2023',
          discontinued_date: '06/09/2023',
          discontinued_stage: 'Early notification',
          reason: 'Paid'
        }
      ],
      holdList: [],
      status: {
        background: '',
        description: '',
        foreground: '',
        name: ''
      },
      isHoldViewLoading: false,
      isRequestHoldLoading: false,
      isReleaseHoldLoading: false,
      isRejectHoldLoading: false,
      isViewHolds: false,
      isViewHoldsConfirm: false,
      requestRestartDialog: false,
      requestRestartDialogLoading: false,
      selectedHoldForView: {
        hold: {
          category: '',
          date_created: '',
          description: '',
          id: 0,
          id_lien: 0,
          id_lien_task: null,
          status: ''
        },
        activity: [],
        restart_stages: {}
      },
      holdRelease_date: '',
      isAddHolds: false,
      isApproveModalOpen: false,
      showDiscontine: false,
      store,
      resendEmailLoading: false,
      fileLoader: false,
      info: {
        renter: {},
        overdue: 0,
        current_liens: [],
        history: [],
        possible_step_list: [],
        auctionModel: {
          start: null,
          end: null
        }
      },
      selectedOrganizationUuid: null,
      holdsRestartSteps: [],
      show_modal: false,
      show_modal2: false,
      image: '',
      lien_task_uuid: null,
      showAddImageModal: true,
      showAddImageModal2: true,
      image_lien_task: null,
      showUploader: true,
      showUploaderPdf: true,
      finalApproval: null,
      upload: null,
      description2: '',
      timezone: '',
      errors: { ...defaultErrors },
      role: this.$store.state.user.role,
      roles: Roles,
      show_complete_modal: false,
      show_resend_email_modal: false,
      mailgun_data: false,
      show_mailgun_modal: false,
      uuidToComplete: null,
      uuidToResend: null,
      completeDate: null,
      completeExecutionDate: null,
      completeExecutionDateId: null,
      completeDateConfig: {
        maxDate: null,
        minDate: null
      },
      uspsImage: null,
      show_usps_image_modal: false,
      show_add_edit_description_modal: false,
      formatCurrency,
      pdfFile: '',
      imagesPfs: [],
      show_change_execution_modal: false,
      isDiscontinueVisible: this.$store.state.user.role === Roles.SUPER_ADMIN,
      printing: false,
      summaryImage: null,
      identified: false,
      isLogsVisible: this.$store.state.user.role === Roles.SUPER_ADMIN,
      auctionInfo: {
        start: null,
        end: null
      },
      holdDescription: '',
      holdCategory: '',
      lienLogs: [],
      documents: [],
      passwordError: {
        message: '',
        visible: false
      },
      activities: [],
      uuid: '',
      passwordInputConfig: {
        text: {
          type: 'password',
          color: '#dbdbdb'
        },
        password: {
          type: 'text',
          color: '#000'
        }
      },
      data: [],
      tempData: [],
      possibleStepName: {
        1: { id_workflow_step_name: 1, name: 'Lien letter notice 1' },
        2: { id_workflow_step_name: 2, name: 'Lien letter notice 2' },
        3: { id_workflow_step_name: 3, name: 'Lien to Sale Letter 1' },
        4: { id_workflow_step_name: 4, name: 'Lien to Sale Letter 2' },
        5: { id_workflow_step_name: 5, name: 'Newspaper 1' },
        6: { id_workflow_step_name: 6, name: 'Newspaper 2' }
      },
      possibleStepList: {
        1: { name: 'SMS', category: 'notification' },
        2: { name: 'Email', category: 'notification' },
        3: { name: 'USPS', category: 'notification' },
        5: { name: 'Newspaper publication', category: 'ad' }
      },
      loggedIn: false,
      isVisibleForCsAdminAndManager: false,
      requestHoldNote: '',
      releaseHoldNote: '',
      accessControl: [],
      aILeanReleaseModel: ''
    };
  },
  computed: {
    tenantFullName() {
      return `${this.info.renter.firstname} ${this.info.renter.middle_initial} ${this.info.renter.lastname}`;
    },
    files() {
      const activeFileTab = this.documentVaultTabs.find((i) => i.isActive);

      switch (activeFileTab.key) {
        case 'active':
          return this.documents.filter(({ is_archived: archived }) => !archived);
        case 'archive':
          return this.documents.filter(({ is_archived: archived }) => !!archived);
        case 'all':
        default:
          return this.documents;
      }
    },
    isOneWorkflowStepCompleted() {
      return this.info.current_liens[0].steps?.some((step) => step.is_executed);
    },
    isDark() {
      return this.$store.getters['common/getDarkMode'];
    }
  },
  async mounted() {
    const organization = this.$store.state.organization || {};
    this.selectedOrganizationUuid = organization && Object.keys(organization).length ? organization.uuid : '';
    this.$root.pageTitle = '';
    this.$root.goBackLink = 'dashboard';
    this.accessControl = this.$store.state.permissions;
    await this.getTenantInfo();
    this.isImage = isImage.bind(this);
    this.isPdf = isPdf.bind(this);

    this.$root.showHeader = true;
    this.isLogsVisible = this.$store.state.user.role === Roles.SUPER_ADMIN;
    this.uuid = this.$route.params.uuid;
    window.addEventListener('keydown', this.handleKeyDown);
    // document.body.addEventListener('scroll', this.handleVisibleElement);
    const isUserLogged = this.$store.state.accessToken
      && this.$store.state.expirationDate > new Date().getTime();

    if (isUserLogged) {
      this.identified = true;
      this.loggedIn = true;

      await this.handleIdentify(null, 'TexasAjM99');
    }
    if (this.role === this.roles.ADMIN || this.role === this.roles.MANAGER) {
      this.isVisibleForCsAdminAndManager = true;
    }
    const [activities, lienHistoryData, documents] = await Promise.all([this.getRenterHistoryUpdate(), this.getRenterHistory(), this.getRenterFiles()]);
    this.activities = activities;
    this.lienHistoryData = lienHistoryData;
    this.documents = documents;
    this.getHoldCategory();
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeyDown);
    document.body.removeEventListener('scroll', debounce(this.handleVisibleElement, 10));
    document.body.removeEventListener('scroll', throttle(this.handleNavigationLinksToVisibleArea, 50));
  },
  methods: {
    hasPermission(...slug) {
      return slug.some((hold) => this.accessControl && this.accessControl.find((it) => it.slug === hold && it.has_permission));
    },
    isShowAddDataBtn(step) {
      return this.isLienSaleStepForAdminAndManager(step) || !this.isVisibleForCsAdminAndManager;
    },
    isLienSaleStepForAdminAndManager(step) {
      return [3, 4].includes(step.id_workflow_step_name) && (this.role === this.roles.ADMIN || this.role === this.roles.MANAGER);
    },
    historyRenterLinkNavigator(id) {
      const whole = window.location.href;
      const url = `${whole.slice(0, whole.indexOf('view/') + 4)}/${id}`;
      this.$router.push(id);
      window.open(url, '_blank');
    },
    async getRenterFiles() {
      const { data: { status, result } } = await userService.getRenterFile(this.$route.params.uuid);
      return status === 'success' ? result.documents : [];
    },
    async getRenterHistory() {
      const { data: { status, result } } = await userService.getRenterHistory(this.$route.params.uuid);
      return status === 'success' ? result : [];
    },
    async getRenterHistoryUpdate() {
      const { data: { status, result } } = await userService.getRenterHistoryUpdates(this.$route.params.uuid);
      return status === 'success' ? result : [];
    },
    convertHoldAction(str) {
      const words = str.split('_');
      const capitalizedWords = words.map((word) => word.charAt(0).toUpperCase() + word.slice(1));
      return capitalizedWords.join(' ');
    },
    isInvalidTextareaNote(message) {
      return message.length < 6 || message.length > 8000;
    },
    formatDate(dateString, type) {
      if (type === 'full') {
        return moment(dateString, 'MM/DD/YYYY HH:mm:ss').format('MM/DD/YYYY HH:mm:ss');
      }
      return moment(dateString, 'MM/DD/YYYY HH:mm:ss').format('MM/DD/YYYY');
    },
    formatMoneyValue(value) {
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      });
      return formatter.format(value);
    },
    getHoldCategoryOfLien(id) {
      dashboardService
        .getHoldCategoryListOfLien(id)
        .then((res) => {
          if (res.status === 200) {
            this.holdTable = res.data.result;
          } else {
            console.log(
              'Something went wrong while fetching hold category list!'
            );
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getHoldCategory() {
      try {
        const [holds] = await Promise.all([
          dashboardService.getHoldCategoryList()
        ]);

        if (holds.status === 200) {
          this.holdList = holds.data.result;
        } else {
          console.log(
            'Something went wrong while fetching hold category list!'
          );
        }
      } catch (error) {
        console.log(error);
      }
    },
    createHold(e) {
      e.preventDefault();
      const requestBody = {
        category: this.holdCategory,
        description: this.holdDescription
      };
      dashboardService
        .createHoldCategory(this.info.current_liens[0].uuid, requestBody)
        .then((res) => {
          if (res.data?.status === 'success') {
            this.hideHoldsAddModal();
            // @todo try to avoid using the restricted globals
            // eslint-disable-next-line no-restricted-globals
            location.reload();
            this.$root.$emit('showToast', {
              message: res.data?.message,
              options: { cssClass: 'is-success', duration: 5000 }
            });
          } else {
            this.$root.$emit('showToast', {
              message: res.data?.message,
              options: { cssClass: 'is-danger', duration: 10000 }
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    showHoldsAddModal() {
      this.isAddHolds = true;
    },
    hideHoldsAddModal() {
      this.isAddHolds = false;
    },
    async showHoldsViewModal(id) {
      try {
        const { status, data } = await dashboardService.getHoldData(id);

        if (status !== 200) {
          console.log('Something wrong while fetching hold data!');
          return;
        }

        this.isHoldViewLoading = true;

        this.selectedHoldForView = data?.result;
        const releasedHold = data?.result?.activity?.find(
          (i) => i.type === 'release'
        );

        const { id_lien_task: idLienTask } = this.selectedHoldForView.hold;

        // Preselect the step of the restart request
        if (idLienTask && Object.keys(this.holdsRestartSteps).length) {
          this.aILeanReleaseModel = idLienTask;

          // @deprecated
          // Get the last activity request
          // const lastActivityRequest = this.selectedHoldForView.activity.at(-1);

          // if (lastActivityRequest.type === 'release_request') {
          //   // Find the index of the step in the holdsRestartSteps object
          //   const preselectStepIndex = Object.values(this.holdsRestartSteps).findIndex((step) => lastActivityRequest.description.matchAll(step.name));

          //   if (preselectStepIndex > -1) {
          //     // Set the preselected step
          //     this.aILeanReleaseModel = Object.keys(this.holdsRestartSteps)[preselectStepIndex];
          //   }
          // }
        }

        this.holdRelease_date = releasedHold && Object.values(releasedHold).length
          ? this.formatDate(releasedHold.date, 'full')
          : '-';
        this.isHoldViewLoading = false;
      } catch (error) {
        this.isHoldViewLoading = false;
      } finally {
        this.isViewHolds = true;
      }
    },
    hideHoldsViewModal() {
      this.isViewHolds = false;
      this.selectedHoldForView = { hold: {}, activity: [], restart_stages: {} };
      this.aILeanReleaseModel = '';
    },
    releaseCautionHandler() {
      const isReleaseRequested = this.selectedHoldForView.hold?.status === 'Pending Release'
        && this.role === this.roles.SUPER_ADMIN;

      const isHoldActive = this.selectedHoldForView.hold?.status === 'Active'
        && this.hasPermission('request_hold');

      if (isHoldActive) {
        this.requestHoldReleaseHandler();
      }

      if (isReleaseRequested) {
        this.approveHoldReleaseHandler();
      }
    },
    requestHoldRelease() {
      this.isRequestHoldLoading = true;

      if (this.$refs.requestRelease.value) {
        this.isViewHoldsConfirm = true;
      } else {
        this.requestHoldReleaseHandler();
      }
    },
    async requestHoldRestartHandler() {
      try {
        if (!this.requestHoldNote || this.isInvalidTextareaNote(this.requestHoldNote)) {
          return;
        }
        this.requestRestartDialogLoading = true;

        const { status, data } = await dashboardService.requestRestartHold(
          this.info.current_liens[0].uuid,
          {
            lien_task: this.$refs.requestRelease && this.$refs.requestRelease.value ? Number(this.$refs.requestRelease.value) : null,
            description: this.requestHoldNote
          }
        );

        if (status === 200) {
          this.isViewHolds = false;
          // @todo try to avoid using the restricted globals
          // eslint-disable-next-line no-restricted-globals
          location.reload();
          this.$root.$emit('showToast', {
            message: data?.message,
            options: { cssClass: 'is-success', duration: 5000 }
          });
        } else {
          console.info('Something wrong while fetching hold data!');
        }
      } catch (error) {
        console.error('[requestHoldRestartHandler]', error);
      } finally {
        this.requestRestartDialogLoading = false;
        this.requestHoldNote = '';
      }
    },
    async requestHoldReleaseHandler() {
      try {
        this.isViewHoldsConfirm = false;

        const { status, data } = await dashboardService.requestReleaseOfHold({
          hold: this.selectedHoldForView.hold.id,
          lien_task: Number(this.$refs.requestRelease.value),
          description: this.requestHoldNote
        });

        if (status === 200) {
          this.isViewHolds = false;
          // @todo try to avoid using the restricted globals
          // eslint-disable-next-line no-restricted-globals
          location.reload();
          this.$root.$emit('showToast', {
            message: data?.message,
            options: { cssClass: 'is-success', duration: 5000 }
          });
        } else {
          console.info('Something wrong while fetching hold data!');
        }
      } catch (error) {
        console.error('[requestHoldReleaseHandler]', error);
      } finally {
        this.isRequestHoldLoading = false;
      }
    },
    approveHoldRelease() {
      this.isReleaseHoldLoading = true;

      if (Number(this.$refs.aILeanRelease.value)) {
        this.isViewHoldsConfirm = true;
      } else {
        this.approveHoldReleaseHandler();
      }
    },
    async approveHoldReleaseHandler() {
      try {
        this.isViewHoldsConfirm = false;

        const { status, data } = await dashboardService.approveReleaseOfHold({
          hold: this.selectedHoldForView.hold.id,
          lien_task: this.$refs.aILeanRelease && this.$refs.aILeanRelease.value ? Number(this.$refs.aILeanRelease.value) : null,
          description: this.releaseHoldNote
        });

        if (status === 200) {
          this.isViewHolds = false;
          // @todo try to avoid using the restricted globals
          // eslint-disable-next-line no-restricted-globals
          location.reload();
          this.$root.$emit('showToast', {
            message: data?.message,
            options: { cssClass: 'is-success', duration: 5000 }
          });
        } else {
          console.info('Something wrong while fetching hold data!');
        }
      } catch (error) {
        console.error('[requestHoldReleaseHandler]', error);
      } finally {
        this.isRequestHoldLoading = false;
      }
    },
    rejectHoldRelease() {
      this.isRejectHoldLoading = true;
      dashboardService
        .rejectReleaseOfHold({
          hold: this.selectedHoldForView.hold.id,
          description: this.releaseHoldNote
        })
        .then((res) => {
          if (res.status === 200) {
            this.isRejectHoldLoading = false;
            this.isViewHolds = false;
            // @todo try to avoid using the restricted globals
            // eslint-disable-next-line no-restricted-globals
            location.reload();
            this.$root.$emit('showToast', {
              message: res.data?.message,
              options: { cssClass: 'is-success', duration: 5000 }
            });
          } else {
            this.isRejectHoldLoading = false;
            console.log('Something wrong while fetching hold data!');
          }
        })
        .catch((err) => {
          console.log(err);
          this.isRejectHoldLoading = false;
        });
    },
    handleDocumentVaultTabs(id) {
      const updated = this.documentVaultTabs.map((i) => (i.id === id ? { ...i, isActive: true } : { ...i, isActive: false }));
      this.documentVaultTabs = updated;
    },
    async handleNavLinks(id, key) {
      const updated = this.navLinks.map((i) => (i.id === id ? { ...i, isActive: true } : { ...i, isActive: false }));
      this.navLinks = updated;
      const el = this.$refs[key];
      if (el) {
        try {
          document.body.scrollTo({ top: el.offsetTop - 175, behavior: 'smooth' });

          // Scroll to a certain element in Navigation
          await this.$nextTick();
          this.handleNavigationLinksToVisibleArea();
        } catch (error) {
          console.log(error);
        }
      }
    },
    handleVisibleElement() {
      const { scrollTop, scrollHeight, offsetHeight: bodyOffsetHeight } = document.body;

      this.navLinks.forEach((nav, index) => {
        const isLast = index === this.navLinks.length - 1;
        const el = this.$refs[nav.key];
        if (el) {
          const offsetTop = el?.offsetTop;
          const offsetHeight = el?.offsetHeight;
          const isIntersecting = scrollTop >= offsetTop - 258
            && scrollTop <= offsetTop + offsetHeight - 200
            && (scrollTop <= scrollHeight - bodyOffsetHeight - 200);

          nav.isActive = isLast ? (scrollTop >= scrollHeight - bodyOffsetHeight - 200 || scrollTop >= offsetTop - 258) : isIntersecting;
        }
      });
    },
    async handleNavigationLinksToVisibleArea() {
      await this.$nextTick();
      const nav = this.navLinks.find((i) => i.isActive);
      if (nav && this.$refs.pageNavigationContainer) {
        const navLink = document.getElementById(`${nav.key}-link`);

        // Scroll to Center of Navigation Link
        const containerCenter = this.$refs.pageNavigationContainer.offsetWidth / 2;
        this.$refs.pageNavigationContainer.scrollTo({
          left: (navLink.offsetLeft - containerCenter) + (navLink.offsetWidth / 2),
          behavior: 'smooth'
        });
      }
    },
    showApproveModal() {
      this.isApproveModalOpen = true;
    },
    hideApproveModal() {
      this.isApproveModalOpen = false;
    },
    handleIdentify(e, pass) {
      e?.preventDefault();
      const password = pass || this.$refs.password.value;
      if (!password) {
        this.passwordError = {
          message: 'Password is required',
          visible: true
        };
        this.$root.$emit('showToast', {
          message: 'Password is required',
          options: { cssClass: 'is-danger', duration: 7500 }
        });
        return;
      }
      const self = this;
      const data = new FormData();
      data.append('password', password);

      authService
        .identify(data, this.uuid)
        .then((response) => {
          const { status, message, result } = response.data;
          if (status === 'success') {
            const firstLien = result.current_liens?.length
              ? result.current_liens[0]
              : {};
            self.summaryImage = result.renter.base64_image;
            self.auctionInfo = {
              start: firstLien.auction,
              end: firstLien.auction_end
            };
            self.lienLogs = firstLien.logs;
          } else {
            self.passwordError = {
              message,
              visible: true
            };
            self.$root.$emit('showToast', {
              message:
                message
                || 'Impossible to perform this action. Be sure to be connected and to have access to this action',
              options: { cssClass: 'is-danger', duration: 10000 }
            });
          }
        })
        .catch(() => {
          self.$root.$emit('showToast', {
            message: 'Technical issue. Please try again later',
            options: { cssClass: 'is-danger', duration: 10000 }
          });
        });
    },
    getStepTitle(step) {
      const {
        is_executed: isExecuted,
        id_workflow_step_type: idWorkflowStepType,
        id_workflow_step_name: idWorkflowStepName,
        execution_date: executionDate
      } = step;
      const stepInfo = [
        this.possibleStepList[idWorkflowStepType]?.name,
        this.possibleStepName[idWorkflowStepName]?.name
      ]
        .filter((it) => it)
        .join(': ');
      if (!isExecuted) {
        return `${stepInfo} - Not completed`;
      }
      const details = this.getDetails(step);
      const completionInfo = details
        ? executionDate
        : `Completed manually - ${executionDate}`;
      /* eslint-enable camelcase */

      return [stepInfo, completionInfo].filter((it) => it).join(' - ');
    },
    getDetails(step) {
      switch (step.id_workflow_step_type) {
        case 2:
          return step.message ? step.message : step?.details?.message || '';
        case 1:
          return step.message ? step.message : step?.details?.message || '';
        case 3:
          return step.usps_image
            ? `<img class="summary__imgs" style="width:100%; margin: 10px 0; object-fit: contain;" src="${step.usps_image}" >`
            : '';
        case 5:
          return step.ordered || '';
        default:
          return null;
      }
    },
    async print() {
      this.printing = true;
      await this.$nextTick();
      await this.$htmlToPaper('printMe', null, () => {
        this.printing = false;
      });
    },
    toggleAll() {
      const isAllOpened = this.data.every((it) => it.active);
      this.data = [...this.data.map((it) => ({ ...it, active: !isAllOpened }))];
    },
    handleKeyDown(e) {
      if (
        (e.ctrlKey || e.metaKey)
        && (e.key.toLowerCase() === 'p' || [16, 80, 112].includes(e.charCode))
      ) {
        e.cancelBubble = true;
        e.preventDefault();
        e.stopImmediatePropagation();
        this.print();
      }
    },
    handleDiscontinueBtn() {
      const { value } = this.$refs.reason;
      const self = this;
      if (!value) {
        this.errors.reason.message = 'Please enter the reason';
        this.errors.reason.visible = true;
        return;
      }
      dashboardService
        .submitReasonDiscontinueBtn(this.info.renter.uuid, { reason: value })
        .then((response) => {
          const { status, message } = response.data;

          if (status === 'success') {
            self.$root.$emit('showToast', {
              message,
              options: { cssClass: 'is-success', duration: 5000 }
            });
            self.errors.reason.visible = false;
            self.$store.commit('setSelectedTab', { reports: 'DELETED_LIENS' });
            self.$router.push('/reports');
          } else {
            self.$root.$emit('showToast', {
              message:
                message
                || 'Impossible to perform this action. Be sure to be connected and to have access to this action',
              options: { cssClass: 'is-danger', duration: 10000 }
            });
          }
        })
        .catch(() => {
          self.$root.$emit('showToast', {
            message:
              'Impossible to perform this action. Be sure to be connected and to have access to this action',
            options: { cssClass: 'is-danger', duration: 10000 }
          });
        });
    },
    hideDiscontinueModal() {
      this.showDiscontine = false;
    },
    showUspsImageModal(image) {
      this.show_usps_image_modal = true;
      this.uspsImage = image;
    },
    hideUspsImageModal() {
      this.show_usps_image_modal = false;
      this.uspsImage = null;
    },
    isDescriptionVisible() {
      return this.info?.renter?.company?.state?.description_required;
    },
    showAddEditDescriptionModal() {
      this.show_add_edit_description_modal = true;
      this.$refs.tenantDescription.value = this.getTenantDescription() || '';
    },
    hideAddEditDescriptionModal() {
      this.show_add_edit_description_modal = false;
      this.errors = { ...defaultErrors };
      this.$refs.tenantDescription.value = '';
    },
    getTenantDescription() {
      return this.info?.renter?.description;
    },
    handleDescriptionSave() {
      const self = this;
      const description = this.$refs.tenantDescription?.value || '';
      // Description is not required
      // ---------------------------
      // let message = '';
      // const tenantDescriptionError = {
      //   visible: false,
      //   message: ''
      // };

      // if (!description) {
      //   message = 'Description is required';
      //   tenantDescriptionError.message = 'Description is required';
      //   tenantDescriptionError.visible = true;
      // }

      // if (message) {
      //   this.$root.$emit('showToast', {
      //     message,
      //     options: { cssClass: 'is-danger', duration: 2500 }
      //   });
      //   this.$refs.tenantDescription.focus();
      //   this.errors = {
      //     ...this.errors,
      //     tenantDescription: tenantDescriptionError
      //   };
      //   return;
      // }
      const data = new FormData();
      data.append('description', description);
      dashboardService
        .saveRenterDescription(this.info.renter.uuid, data)
        .then((response) => {
          // @todo SHADOW variable!
          // eslint-disable-next-line no-shadow
          const { status, message } = response.data;

          if (status === 'success') {
            self.$root.$emit('showToast', {
              message,
              options: { cssClass: 'is-success', duration: 5000 }
            });
            self.getTenantInfo();
            self.hideAddEditDescriptionModal();
          } else {
            self.$root.$emit('showToast', {
              message:
                message
                || 'Impossible to perform this action. Be sure to be connected and to have access to this action',
              options: { cssClass: 'is-danger', duration: 10000 }
            });
          }
        })
        .catch(() => {
          self.$root.$emit('showToast', {
            message:
              'Impossible to perform this action. Be sure to be connected and to have access to this action',
            options: { cssClass: 'is-danger', duration: 10000 }
          });
        });
    },
    async getTenantInfo() {
      const self = this;

      return userService
        .getRenterView(this.$route.params.uuid)
        .then(async (response) => {
          const { status, result } = response.data;

          if (status === 'success') {
            self.getHoldCategoryOfLien(result.current_liens[0].uuid);
            const info = result;
            self.setActionVisibility(info);
            const auctionModel = self.prepareAuction(info) || {
              start: null,
              end: null
            };
            info.current_liens = self.prepareLiens(info.current_liens);
            info.renter.name = `${info.renter.firstname} ${info.renter.middle_initial} ${info.renter.lastname}`;
            info.renter.chargesbal = parseFloat(info.renter.chargesbal);
            info.renter.company.late_fee = parseFloat(
              info.renter.company.late_fee
            );
            info.renter.company.additional_fee = parseFloat(
              info.renter.company.additional_fee
            );
            info.auctionModel = auctionModel;
            self.showAddImageModal = !info.renter.base64_image;
            self.showUploader = !info.renter.base64_image;
            self.info = info;
            self.status = result.current_liens[0].status;
            if (!self.$root.pageTitle) {
              self.$root.pageTitle = `${info.renter.name}'s procedure details`;
            }

            const { data: { result: holdsRestartSteps } } = await dashboardService.fetchHoldsData(info.current_liens[0].uuid);
            self.holdsRestartSteps = holdsRestartSteps;

            setTimeout(() => {
              document.body.addEventListener('scroll', debounce(this.handleVisibleElement, 10));
              document.body.addEventListener('scroll', throttle(this.handleNavigationLinksToVisibleArea, 50));
            }, 200);
          } else {
            self.$root.$emit('showToast', {
              message:
                'Impossible to perform this action. Be sure to be connected and to have access to this action',
              options: { cssClass: 'is-danger', duration: 10000 }
            });
          }
        })
        .catch(() => {
          self.$root.$emit('showToast', {
            message:
              'Impossible to perform this action. Be sure to be connected and to have access to this action',
            options: { cssClass: 'is-danger', duration: 10000 }
          });
        });
    },
    isResendVisible(step, idx) {
      return (
        !step.is_executed
        && [3, 4, 1, 2].includes(step.id_workflow_step_name)
        && step.id_workflow_step_type === 2
        && (this.info.current_liens[0].steps[idx - 1]?.is_executed || idx - 1 < 0)
      );
    },
    isMailgunVisible(step) {
      return step.mailgun_data;
    },
    isImageAddVisible(step) {
      let check = step?.details?.message ? true : !!step?.message;
      // eslint-disable-next-line no-nested-ternary
      check = check ? true : !step?.is_executed ? true : !!step?.usps_image;
      return check ? true : step.ordered;
    },
    isCompleteVisible(step, idx) {
      return (
        !step.is_executed
        && (this.info.current_liens[0].steps[idx - 1]?.is_executed || idx === 0)
        && !this.isVisibleForCsAdminAndManager
      );
    },
    prepareLiens(currentLiens) {
      if (currentLiens?.length) {
        currentLiens[0].steps = currentLiens[0].steps.map((currentLien) => ({
          ...currentLien,
          show_menu: false
        }));
      }
      return currentLiens;
    },
    showChangeExecutionDateModal(step) {
      this.completeExecutionDateId = step.uuid;
      this.show_change_execution_modal = true;
    },
    hideChangeExecutionDateModal() {
      this.show_change_execution_modal = false;
    },
    handleCompleteChangeClick() {
      const date = this.completeExecutionDate?.toISOString().split('T')[0] || null;
      dashboardService
        .changeExecutionDate(this.completeExecutionDateId, date)
        .then((res) => {
          if (res.data.status === 'success') {
            this.show_change_execution_modal = false;
            window.location.reload();
            this.$root.$emit('showToast', {
              message: res.data.message || 'Date successfully uploaded',
              options: { cssClass: 'is-success', duration: 5000 }
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.show_change_execution_modal = false;
          this.$root.$emit('showToast', {
            message: 'Technical issue. Please try again later',
            options: { cssClass: 'is-danger', duration: 10000 }
          });
        });
    },
    isStepExecuted: (step) => step.is_executed,
    showCompleteModal(step, index) {
      const previousStep = this.info.current_liens[0].steps[index - 1];
      this.show_complete_modal = true;
      this.uuidToComplete = step.uuid;
      this.completeDate = null;
      const now = new Date();
      // const yesterday = new Date(now.getTime());
      // yesterday.setDate(now.getDate() - 1);
      const maxDate = now;
      let minDate = null;

      if (previousStep) {
        minDate = new Date(previousStep.execution_date);
      }
      this.completeDateConfig = {
        maxDate,
        minDate
      };
    },
    deleteImage(image, index) {
      if (!image.mime) {
        this.imagesPfs = this.imagesPfs.filter(
          (_, indexToCompare) => index !== indexToCompare
        );
        return;
      }

      const self = this;
      userService
        .deleteLienFile(image.id)
        .then((response) => {
          const { status, message } = response.data;
          if (status === 'success') {
            self.$router.go();
            self.$root.$emit('showToast', {
              message: message || 'File successfully deleted',
              options: { cssClass: 'is-success', duration: 5000 }
            });
            self.imagesPfs = self.imagesPfs.filter(({ id }) => id !== image.id);
          } else {
            self.$root.$emit('showToast', {
              message:
                message || 'Impossible to delete the file. Please try later',
              options: { cssClass: 'is-danger', duration: 5000 }
            });
          }
        })
        .catch(() => {
          self.$root.$emit('showToast', {
            message: 'Technical issue. Please try again later',
            options: { cssClass: 'is-danger', duration: 10000 }
          });
        });
    },
    showAddDataModel(step) {
      this.show_modal2 = true;
      this.image_lien_task = step.image_manual && step.image_manual !== 'null'
        ? step.image_manual
        : false;
      this.description2 = step.description_manual;
      this.lien_task_uuid = step.uuid;
      this.showUploaderPdf = !step.pdf;
      this.pdfFile = step.pdf;
      this.imagesPfs = step.images_pdfs
        ? step.images_pdfs.filter((image) => image.mime)
        : [];
    },
    hideAddDataModel() {
      this.show_modal2 = false;
      this.image_lien_task = null;
      this.description2 = null;
      this.lien_task_uuid = null;
      this.showUploaderPdf = false;
      this.pdfFile = '';
      this.imagesPfs = [];
    },
    hideCompleteModal() {
      this.show_complete_modal = false;
      this.uuidToComplete = null;
      this.completeDate = null;
      this.completeDateConfig = {
        maxDate: null,
        minDate: null
      };
    },
    handleCompleteClick() {
      if (!this.uuidToComplete) {
        return;
      }
      const self = this;
      const auction = this.completeDate?.toISOString() || null;

      const data = new FormData();
      data.append('auction', auction);
      dashboardService
        .updateExecuteDate(this.uuidToComplete, data)
        .then((response) => {
          const { status, message } = response.data;

          if (status === 'success') {
            self.$root.$emit('showToast', {
              message,
              options: { cssClass: 'is-success', duration: 5000 }
            });
            self.getTenantInfo();
          } else {
            self.$root.$emit('showToast', {
              message:
                message
                || 'Impossible to perform this action. Be sure to be connected and to have access to this action',
              options: { cssClass: 'is-danger', duration: 10000 }
            });
          }
        })
        .catch(() => {
          self.$root.$emit('showToast', {
            message:
              'Impossible to perform this action. Be sure to be connected and to have access to this action',
            options: { cssClass: 'is-danger', duration: 10000 }
          });
        })
        .finally(() => {
          self.hideCompleteModal();
        });
    },
    showResendEmailModal(uuid) {
      this.show_resend_email_modal = true;
      this.uuidToResend = uuid;
      this.completeDate = null;
    },
    showMailgunData(uuid) {
      this.show_mailgun_modal = true;
      this.mailgun_data = uuid;
    },
    hideResendEmailModal() {
      this.show_resend_email_modal = false;
      this.uuidToResend = null;
      this.completeDate = null;
    },
    hideMailgunModal() {
      this.show_mailgun_modal = false;
      this.mailgun_data = null;
    },
    handleResendEmailClick() {
      if (!this.uuidToResend) {
        return;
      }
      const self = this;
      self.resendEmailLoading = true;
      userService
        .executeLienTask(this.uuidToResend)
        .then((response) => {
          const { status, message } = response.data;
          if (status === 'success') {
            // @todo try to avoid using the restricted globals
            // eslint-disable-next-line no-restricted-globals
            location.reload();
            self.getTenantInfo();
          } else {
            self.$root.$emit('showToast', {
              message,
              options: { cssClass: 'is-danger', duration: 10000 }
            });
          }
        })
        .catch(() => {
          self.$root.$emit('showToast', {
            message: 'Technical issue. Please try again later',
            options: { cssClass: 'is-danger', duration: 10000 }
          });
        })
        .finally(() => {
          self.hideResendEmailModal();
          self.resendEmailLoading = false;
        });
    },
    prepareAuction(info) {
      const currentLien = info?.current_liens?.length
        ? info?.current_liens[0]
        : null;

      if (currentLien && currentLien.auction && currentLien.auction_end) {
        return {
          start: info.current_liens[0].auction,
          end: info.current_liens[0].auction_end
        };
      }
      return null;
    },
    globalFees(lien) {
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0
      });
      return formatter.format(
        parseFloat(lien.late_fee) + parseFloat(lien.additional_fee)
      );
    },
    getLastNotificationSent(lien) {
      let res = '/';
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < lien.steps.length; i++) {
        if (lien.steps[i].is_executed) {
          res = this.info.possible_step_list[lien.steps[i].id_workflow_step_type]
            .name;
        }
      }
      return res;
    },
    approveFinalButton(e) {
      e.preventDefault();
      const self = this;
      dashboardService
        .approveFinalApprovals([{ lien_uuid: this.info.current_liens[0].uuid }])
        .then((response) => {
          if (response.data.status === 'success') {
            self.getTenantInfo();
            self.isApproveModalOpen = false;
          } else {
            self.isApproveModalOpen = false;
            self.$root.$emit('showToast', {
              message: 'Impossible to update status. Please try later',
              options: { cssClass: 'is-danger', duration: 10000 }
            });
          }
        })
        .catch(() => {
          self.$root.$emit('showToast', {
            message: 'Technical issue. Please try again later',
            options: { cssClass: 'is-danger', duration: 10000 }
          });
        });
    },
    copyUspsCode(uspsCode) {
      const self = this;
      this.$copyText(uspsCode).then(
        () => {
          self.$root.$emit('showToast', {
            message: 'Usps code copied successfully',
            options: { cssClass: 'is-success', duration: 2500 }
          });
        },
        () => {
          self.$root.$emit('showToast', {
            message: 'Failed to copy usps code. Please try again',
            options: { cssClass: 'is-danger', duration: 2500 }
          });
        }
      );
    },
    handleUploadClick() {
      this.show_modal = true;
    },
    hideAddModal() {
      this.show_modal = false;
      this.show_modal2 = false;
      this.showAddImageModal = !this.info.renter.base64_image;
      this.errors = { ...defaultErrors };
    },
    uploadImage(event) {
      if (!event.target.files[0]) {
        this.$root.$emit('showToast', {
          message: 'Choose at least on file',
          options: { cssClass: 'is-danger', duration: 5000 }
        });
        return;
      }

      [...event.target.files].forEach((file) => {
        if (!isImage(file.name) && !isPdf(file.name)) {
          this.$root.$emit('showToast', {
            message: 'Only images or pdfs are allowed to be uploaded',
            options: { cssClass: 'is-danger', duration: 5000 }
          });
          this.$refs.uploadInput.value = '';
          this.image = '';
          return;
        }
        if (!isValidSize(file.size, 10)) {
          this.$root.$emit('showToast', {
            message: 'File size is too big. Please choose the smaller file',
            options: { cssClass: 'is-danger', duration: 5000 }
          });
          this.$refs.uploadInput.value = '';
          this.image = '';
          this.pdfFile = '';
          return;
        }

        this.imagesPfs.push(file);
      });

      this.$refs.uploadInput.value = null;
    },
    handleAddClick() {
      const self = this;
      const { image } = this;
      const description = this.$refs.description.value || '';

      if (description.length > 250) {
        this.$root.$emit('showToast', {
          message: 'Maximum character count for the Text area is 250',
          options: { cssClass: 'is-danger', duration: 2500 }
        });
        this.$refs.description.focus();
        this.errors = {
          ...this.errors,
          description: {
            visible: true,
            message: 'Maximum character count for the Text area is 250'
          }
        };
        return;
      }
      if (!image) {
        return;
      }
      userService
        .uploadPhoto(this.info.renter.uuid, {
          base64_image: image,
          image_description: description
        })
        .then((response) => {
          const { status, message } = response.data;
          if (status === 'success') {
            self.$root.$emit('showToast', {
              message: message || 'Image successfully uploaded',
              options: { cssClass: 'is-success', duration: 5000 }
            });
            self.getTenantInfo();
            self.hideAddModal();
          } else {
            self.$root.$emit('showToast', {
              message:
                message || 'Impossible to upload an image. Please try later',
              options: { cssClass: 'is-danger', duration: 5000 }
            });
          }
        })
        .catch(() => {
          self.$root.$emit('showToast', {
            message: 'Technical issue. Please try again later',
            options: { cssClass: 'is-danger', duration: 10000 }
          });
        });
    },
    handleAddClickManual() {
      const self = this;
      const image = this.image_lien_task;
      const description = this.$refs.description2.value || '';
      if (description.length > 250) {
        this.$root.$emit('showToast', {
          message: 'Maximum character count for the Text area is 250',
          options: { cssClass: 'is-danger', duration: 2500 }
        });
        this.$refs.description2.focus();
        this.errors = {
          ...this.errors,
          description: {
            visible: true,
            message: 'Maximum character count for the Text area is 250'
          }
        };
        return;
      }
      const data = new FormData();
      data.append('image_manual', image);
      data.append('description_manual', description);
      this.imagesPfs.forEach((item) => {
        data.append('files[]', item);
      });
      this.fileLoader = true;
      userService
        .uploadLienTaskPhotoPdf(this.lien_task_uuid, data)
        .then((response) => {
          const { status, message } = response.data;
          if (status === 'success') {
            self.fileLoader = false;
            self.$root.$emit('showToast', {
              message: message || 'Image successfully uploaded',
              options: { cssClass: 'is-success', duration: 5000 }
            });
            self.getTenantInfo();
            self.hideAddModal();
            self.$router.go();
          } else {
            self.fileLoader = false;
            self.$root.$emit('showToast', {
              message:
                message || 'Impossible to upload an image. Please try later',
              options: { cssClass: 'is-danger', duration: 5000 }
            });
          }
        })
        .catch(() => {
          self.$root.$emit('showToast', {
            message: 'Technical issue. Please try again later',
            options: { cssClass: 'is-danger', duration: 10000 }
          });
        });
    },
    handleEditClick() {
      this.showAddImageModal = true;
      this.showUploader = false;

      setTimeout(() => {
        if (this.$refs.description) {
          this.$refs.description.value = this.info.renter.image_description || '';
        }
        this.image = this.info.renter.base64_image || '';
      }, 0);
    },
    handleChangePhoto() {
      this.showUploader = true;
    },
    setActionVisibility(info) {
      const currentLiens = info?.current_liens;
      if (currentLiens?.length) {
        const allStepsAreDone = currentLiens[0].steps.every(
          (step) => step.is_executed
        );

        if (
          [Roles.ADMIN, Roles.CS_ADMIN, Roles.SUPER_ADMIN].includes(
            this.$store.state.user.role
          )
          && !info.renter.status_done
        ) {
          this.finalApproval = {
            disabled: !currentLiens[0]?.ready_for_approval ?? true
          };
          this.upload = null;
        } else {
          this.finalApproval = null;
          this.upload = {
            disabled: !allStepsAreDone || !currentLiens[0]?.ready_for_approval
          };
        }
      }
    },
    getStepName(info, step) {
      return [
        info.possible_step_list[step.id_workflow_step_type]?.name,
        info.possible_step_name[step.id_workflow_step_name]?.name
      ]
        .filter((it) => it)
        .join(': ');
    },
    async saveAuction() {
      if (this.role !== this.roles.SUPER_ADMIN) return;

      try {
        const [firstStep] = this.info.current_liens[0].steps;
        const { start, end } = this.info.auctionModel;

        if (!firstStep || !start || !end) {
          return;
        }

        const data = new FormData();
        data.append('auction', this.getDate(start.toString()));
        data.append('auction_end', this.getDate(end.toString()));

        const { data: { status, message } } = await dashboardService.savePublication(firstStep.uuid, data);

        if (status === 'success') {
          this.$root.$emit('showToast', {
            message: message || 'Newspaper publication successfully updated',
            options: { cssClass: 'is-success', duration: 5000 }
          });
          this.auctionDialog = false;
          await this.getTenantInfo();
        } else {
          this.$root.$emit('showToast', {
            message:
              message
              || 'Impossible to perform this action. Be sure to be connected and to have access to this action',
            options: { cssClass: 'is-danger', duration: 10000 }
          });
        }
      } catch (error) {
        console.log('Error', error);

        this.$root.$emit('showToast', {
          message:
            'Impossible to perform this action. Be sure to be connected and to have access to this action',
          options: { cssClass: 'is-danger', duration: 10000 }
        });
      }
    },
    getDate(date) {
      date = date.substr(0, date.indexOf('('));
      return date.trim();
    },
    printLetter(id) {
      const [letterToPrint] = this.$refs[`letter-${id}`];

      if (letterToPrint) {
        const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
        WinPrint.document.write(letterToPrint.innerHTML);
        WinPrint.document.close();
        WinPrint.focus();
        WinPrint.print();
        WinPrint.onafterprint = () => {
          WinPrint.close();
        };
      }
    }
  }
};
</script>
<style
  scoped
  src="../../../public/assets/css/bulma-extension/bulma-tooltip.min.css"
></style>

<style scoped lang="scss">
.underline {
  text-decoration: underline;
}
.d-column {
  display: flex;
  flex-direction: column;
}
.loader {
  border: 16px solid #f3f3f3;
  border-top: 16px solid #3498db;
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
  margin: 0 auto;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.lien-box-val {
  flex: 0.5;
}

.lien-value-box {
  @apply
    h-10
    items-center
    grid
    gap-2
    grid-cols-3;

  dt {
    @apply font-bold;
  }

  dd {
    @apply col-span-2;
  }
}

.lien-box-label {
  margin-right: 12px !important;
  text-align: right;
  font-weight: bold;
}
.lien-box__one {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}

.log__container {
  display: flex;
  align-items: center;
  justify-content: left;
}

.log__container > * {
  margin: 0;
  margin-right: 10px;
}

.btn-groups {
  display: flex;
  justify-content: flex-end;
}
.btn {
  padding: 5px 15px;
  border-radius: 10px;
  border: none;
  outline: none;
  background-color: #3298dc;
  border-color: transparent;
  color: #fff;
  margin-left: 10px;
}
.btn:hover {
  background-color: #3298dc;
  color: #333;
}
.tenant-view {
  p {
    line-height: 1.5em;
  }

  .lien-box {
    &__row {
      display: grid;
      grid-template-columns: 50% 50%;
      margin: 2px;
      p {
        margin: 0;
      }
    }

    &-missing {
      display: inline;
      color: #fff;
      background: #333;
      padding: 2px 4px;
      font-weight: bold;
    }
  }

  .d-flex {
    display: flex;
    flex-direction: column;
  }
  .table__header {
    display: flex;
    align-items: center;
    margin-top: 25px;
    margin-bottom: 15px;
    p {
      margin-right: 20px;
      font-weight: bold;
    }
  }
  .lien__table {
    margin-bottom: 20px;
    & > * {
      width: 100%;
    }

    :deep td, :deep th {
      // white-space: nowrap;
    }
  }
  .horizontal-timeline {
    display: flex;
    justify-content: space-between;
    position: relative;
    flex-wrap: wrap;
    overflow-x: hidden;
    box-sizing: border-box;
    height: auto;

    .step {
      position: relative;
      box-sizing: border-box;
      min-height: 80px;

      @screen md {
        min-height: 160px;
      }

      .content {
        display: block;
        margin-top: 2em;
        text-align: center;
        font-weight: 400;
        font-size: 0.8em;

        @apply
          text-muted-600
          dark:text-muted-500;

        .skip {
          color: #ff0000;
          font-weight: bold;
          border: none;
        }
      }

      &:not(:last-child):before {
        content: "";
        position: absolute;
        top: 1.95rem;
        left: 100%;
        transform: translateY(-50%);
        height: 1px;
        width: 100vw;
        z-index: 0;

        @apply
          bg-muted-600
          dark:bg-muted-500;
      }
    }

    .tag {
      box-sizing: border-box;
      // z-index: 10;
      position: relative;
      border-width: 1rem;
      height: auto;
      line-height: 2.5em;
      padding: 0 1rem;

      @apply
        border-solid
        border-muted-50
        dark:border-muted-900;

      &:after {
        content: attr(data-date);
        position: absolute;
        bottom: -1rem;
        left: 50%;
        transform: translate(-50%, 50%);
        color: rgba(var(--bordeaux), 0.7);
        font-size: 0.8rem;
        font-weight: 400;

        @apply
          text-muted-600
          dark:text-muted-400;
      }

      i {
        margin-right: 0.5rem;
      }

      .card-header-icon {
        max-width: 72px;
        padding: 0;
        height: 100%;

        .dropdown {
          margin-left: 10px;

          .dropdown-trigger {
            height: inherit;

            button {
              display: flex;
              padding: 0;
              text-align: right;
              height: 100%;
              background: transparent;
              outline: none !important;
              box-shadow: none !important;

              span {
                height: inherit;
                i {
                  height: inherit;
                  margin: 0;
                }
              }
            }
          }
        }

        .dropdown-menu {
          left: unset;
          right: 0;
          z-index: 20;
          .dropdown-content {
            max-height: 104px;
            overflow: auto;
          }
        }
      }
    }

    .step + .step {
      // z-index: 1;
      .tag {
        &:before {
          content: "";
          position: absolute;
          top: 50%;
          left: -1rem;
          transform: translate(-100%, -50%);
          width: 0;
          height: 0;
          border-top: 5px solid transparent !important;
          border-bottom: 5px solid transparent !important;
          border-left: 5px solid #c4c4c4;
          z-index: 0;

          @apply
            border-muted-600
            dark:border-muted-500;
        }
      }
    }
  }

  .content {
    table {
      td,
      th {
        border: 0;
        padding: 0rem 2rem;
        line-height: 3.6em;
      }
    }

    td {
      border-top: 1px solid #dbdbdb;
    }
  }

  .has-border-left {
    border-left: 1px solid #dbdbdb !important;
  }

  .columns {
    + .columns {
      margin-top: 3rem;
    }

    .on-going-process {
      display: flex;
      justify-content: space-between;

      h5 {
        margin-bottom: 1.9rem;
      }

      .auction-input {
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        justify-content: flex-end;

        p {
          width: 100%;
          text-align: center;
        }

        .vc-datepicker {
          margin-top: 10px;

          .picker-input {
            display: flex;
            flex-direction: column;

            span {
              height: 20px;
            }
          }
        }
      }
    }

    .tenant-description {
      .description-header {
        display: flex;
        align-items: center;

        .button {
          margin-left: 30px;
          padding: 0;
          border: none;
          outline: none;
        }
      }

      .description {
        padding-right: 10px;
        word-break: break-all;
        max-height: 150px;
        overflow-x: hidden;
        overflow-y: auto;
      }
    }
  }

  .copy-button,
  .final-approval-button,
  .upload-button {
    border: none;
    outline: none;
    cursor: pointer;

    &:disabled {
      cursor: default;
    }
  }

  .actions {
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    align-items: flex-end;
    .final-approval-button,
    .upload-button {
      margin-top: 15px;
      color: #fff;

      &:disabled {
        cursor: default;
      }
    }
  }

  .copy-button span {
    border: none;
  }

  .thumbnail-image {
    width: 250px;
    cursor: pointer;
  }

  .modal {
    .modal__content {
      width: 100%;
    }
    .content__row {
      display: flex;
      width: 100%;
      margin-bottom: 8px;
    }
    .content__label {
      width: 50%;
      font-weight: bold;
    }
    .content__value {
      width: 50%;
    }
    .content__desc > * {
      width: 100%;
    }
    .content__subtitle {
      font-weight: bold;
      margin-top: 12px;
    }
    .content__text {
      margin: 0 0 8px 0;
    }
    .modal-title {
      font-size: 26px;
      font-weight: 600;
    }
    .modal-btns {
      margin-bottom: 8px;
      margin-top: 32px;
    }
    .label {
      font-size: 17px;
      font-weight: 600;
      margin-bottom: 7px;
    }
    .field {
      margin-bottom: 20px;
    }
    .border-bottom {
      width: 100%;
      height: 2px;
      background: #dfeffc;
      margin-bottom: 10px;
    }
    .modal-content {
      .box {
        min-height: 400px;
        max-height: 700px;
        display: flex;
        flex-direction: column;
        overflow: auto;
        justify-content: space-between;

        textarea {
          height: 150px !important;
          resize: none;
        }

        .upload-image {
          margin-top: 15px;
          display: flex;
          flex-flow: column wrap;
          align-items: flex-start;

          .not_uploaded {
            margin: 5px 5px 5px 0;
            padding: 9px;
            border-radius: 4px;
          }
          .image-preview {
            margin-left: 15px;
            width: 50px;
            height: 50px;
            border-radius: 5px;
            cursor: pointer;
            transition: transform 0.3s;
            z-index: 1;

            &:hover {
              transform: scale(2.5);
              border-radius: 0;
            }
          }
        }

        &.edit {
          height: auto;

          .view-image {
            .image-description {
              max-height: 100px;
            }

            .image-preview {
              margin-top: 10px;
              max-height: 400px;
            }
          }

          .control {
            margin-top: 10px;
          }
        }
      }
    }

    &.resend-email-modal,
    &.complete-modal {
      .modal-content {
        .box {
          height: unset;

          .control {
            display: flex;
            justify-content: space-between;
          }
        }
      }
    }

    &.add-description {
      .modal-content {
        .box {
          height: unset;

          .control {
            display: flex;
            justify-content: space-between;
          }

          .modal-footer {
            margin-top: 15px;
          }
        }
      }
    }

    &.usps-image-modal {
      .modal-content {
        .box {
          height: unset;

          .usps-image {
            img {
              max-height: 600px;
            }
          }

          .control {
            display: flex;
            justify-content: flex-end;
          }
        }
      }
    }
  }

  .tenant-image {
    width: 50px;
    height: 50px;
    cursor: pointer;
  }
}
.lien-wrapper {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  position: relative;

  @apply p-3 sm:p-5 md:p-8
    border
    border-muted-300
    dark:border-muted-600
  ;
}
.lien-details-wrapper {
  margin-bottom: 40px;
  margin-top: 60px;
  padding-top: 38px;
  &-title {
    position: absolute;
    top: -29px;
    left: 18px;

    @apply
      bg-muted-50
      dark:bg-muted-900;
  }
}
.lien-details-header {
  position: sticky;
  top: 0;
  z-index: 27;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  border-bottom: 1px solid black;

  @apply
    bg-muted-50
    border-muted-300
    dark:border-muted-600
    dark:bg-muted-900;

  h4 {
    font-size: 1.5rem;
    font-weight: bold;
  }

  .nav__link {
    // background-color: #ade0e6;
    color: #00050b;
    border-radius: 5px;
    padding: 3px 8px;
    font-weight: bold;
    cursor: pointer;

    &--active {
      border: 1px solid #585276;
      background-color: #d1cee2;
    }
  }
}
.vuetable {
  border-radius: 5px;
  -webkit-box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, 0.1),
    0 0px 0 1px rgba(10, 10, 10, 0.02);
  box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, 0.1),
    0 0px 0 1px rgba(10, 10, 10, 0.02);
}
.archive__flag {
  display: inline-block;
  height: 25px;
  width: 25px;
  line-height: 25px;
  text-align: center;
  margin-left: 4px;
  border-radius: 50%;
  background: #b5b5b5;
  font-weight: bold;
  color: #666;
  position: relative;
  display: inline-block;
  cursor: pointer;
}
.custom__tooltip {
  position: absolute;
  left: -6rem;
  bottom: -20%;
  font-weight: 400;
  transform: translateX(-50%);
  background-color: #333;
  color: #fff;
  padding: 0.5rem;
  border-radius: 4px;
  font-size: 12px;
  opacity: 0;
  transition: opacity 0.3s;
  z-index: 20;
}

.archive__flag:hover .custom__tooltip {
  opacity: 1;
}

.history-table-row {
  td {
    @apply w-1/4;
  }
  .min-notes {
    white-space: normal;
    min-width: 250px;

    @apply w-1/3;
  }
}

.hold-details-dialog {
  width: 100%;
  min-width: unset;
  max-height: unset;
  height: 100%;

  .box {
    max-height: unset !important;
    height: 100%;
  }

  @screen md {
    min-width: 650px;
    max-width: 50vw;
    height: max-content;
    max-height: calc(100vh - 160px);
  }
}

.tabs.is-toggle li.is-active a {
  @apply
    bg-primary-500
    border-primary-600
    dark:bg-primary-400
    dark:border-primary-600;
}

.tabs.is-toggle a {
  @apply
    text-muted-950
    dark:text-muted-50;

  &:hover {
    @apply
      bg-muted-200
      dark:bg-muted-800;
  }
}

.page-navigation {
  scroll-behavior: smooth;
}
</style>
